














































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from '@/services/store';
import {Ax} from "@/utils";
import { BrbpDri } from '@/modules/budget-request/components/js/dri';
import { BrbpSee } from '@/modules/budget-request/components/js/see';
import { BrbpPee } from '@/modules/budget-request/components/js/pee';
import { Brbp } from '@/modules/budget-request/components/js/brbp';
import {
    BrbpPprWrapper,
    BrbpWrapper,
    IBrbpWrapper
} from '@/modules/budget-request/components/js/brbp-wrapper';
import CTableBudgetExpend from '@/modules/budget-request/components/table-budget-expend.vue';
import CTableDriEdit from '@/modules/budget-request/components/table-dri-edit.vue';
import CTableBudgetFr from '@/modules/budget-request/components/table-budget-fr.vue';
import CBudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import CTableBudgetEffect from '@/modules/budget-request/components/table-budget-effect.vue';
import CBreadCrumbs from './components/table-dri-breadcrumbs.vue';
import CActionModal from './components/action-modal.vue';
import CDeleteConfirmModal from './components/delete-confirm-modal.vue';
import CBudgetProgramInfo from './components/budget-program-info.vue';
import { BpCosts } from '@/modules/budget-request/components/js/bpInterfaces';
import { sortDriRowsByRegionAndId } from '@/modules/budget-request/components/js/row-hierarchy';
import { mixins } from 'vue-class-component';
import BudgerRequestMixin from './mixins/bp-mixin';
import BudgerRequestDataValidationMixin from './mixins/bp-data-validation-mixin';
import CBudgetProgramFilter from './budget-program-filter.vue';

const PRG_CURR = 0; // ID текущей программы
const PRG_DEV = 1; // ID программы развития

// запись справочника версий отчетов (dict_report_versions), актуальная для конкретного года
interface IReportVersionActual {
    version: number;
    display_name_ru: string;
    display_name_kk: string;
    [key: string]: number | string;
}
@Component({
    name: 'c-budg-program',
    components: { 'c-table-budget-expend': CTableBudgetExpend,
        'c-table-dri-edit': CTableDriEdit,
        'c-budg-form-lst': CBudgetFormsList,
        'c-breadcrumbs': CBreadCrumbs,
        'c-table-budget-fr': CTableBudgetFr,
        'c-table-budget-effect': CTableBudgetEffect,
        'c-budget-program-filter': CBudgetProgramFilter,
        'c-action-modal': CActionModal,
        'c-delete-confirm-modal': CDeleteConfirmModal,
        'c-budget-program-info': CBudgetProgramInfo }
})

export default class CBudgProgram extends mixins(BudgerRequestMixin, BudgerRequestDataValidationMixin) {

    @Prop({
        required: false,
        default: false
    })
    private conclMode!: boolean;

    private isHomePageActive = true;

    private get bpInfoTextLines(): string[] {
        return [
            this.getBPText('list.info_intro', { mode: this.getBPText('mode_title') }),
            this.getBPText('list.info_descr_includes'),
            this.getBPText('list.info_general'),
            this.getBPText('list.info_ppr'),
            this.getBPText('list.info_effect')
        ];
    }

    private switchPages(action = 'enterEditMode') {
        if (action === 'exitEditMode') {
            this.isUserEditMode = false;
            this.$emit('setBpInEditMode', false);
            this.resetProgData();
        }
        this.showTop = false;
        this.isHomePageActive = !this.isHomePageActive;
        this.$root.$emit('removeClass');
    }

    // сброс данных, загруженных для конкретной программы при открытии её карточки
    private resetProgData(): void {
        this.curProg = null;
        this.curPrgId = null;
        this.goal = null;
        this.bpId = null;
        this.editMode = false;
        this.curSubProg = null;
        this.subProgBase = [];
        this.brbpWrapper = new BrbpWrapper();
        this.bpExpendsDataBase = [];
        this.bpExpendsData = {};
        this.brbpDescr = { descrRu: '', descrKK: '' };
        this.descrInfl = [];
        this.conclusions = {
            conclNpaRu: null,
            conclDescrRu: null,
            conclFrRu: null,
            conclExpendRu: null,
            conclDriRu: null,
            conclNpaCode: null,
            conclDescrCode: null,
            conclFrCode: null,
            conclExpendCode: null
        };
        this.selectedTable = 'ppr';
        this.showConcl = this.conclMode;
        this.newGoalsAndFr = [];
        this.isDriDataReady = false;
        this.bpGoalsList = [];
        this.curRegulatory = [];
        this.curGovLevel = null;
        this.curContentDict = null;
        this.curImplementWay = null;
        this.curGoals = null;
        this.curBpGoalFrs = [];
        this.dataChanged = false;
    }
    private progress = 0;
    private tableFieldsTest = [
        {
            key: 'collapse',
            label: ' ',
            class: 'toggle-show'
        },
        {
            key: 'gr',
            label: 'Код'
        },
        {
            key: 'name_ru',
            label: 'Функциональная группа'
        },
        {
            key: 'abp',
            label: 'АБП'
        },
        {
            key: 'prg',
            label: 'ПРОГРАММА'
        },
        {
            key: 'name_ru1',
            label: 'НАИМЕНОВАНИЕ'
        },
        {
            key: 'action',
            label: ''
        }

    ];
    private tableFieldsItems: any = [];

    private curFormSelect = '/budget-program';
    private brbpPprSelected: IBrbpWrapper = new BrbpPprWrapper(undefined, [], [], []);
    private dataChanged = false;
    private isUserEditMode = false;

    private commonResources: any = {
        pprList: []
    };

    private driTopOffset: string | null = null;
    private costTopOffset: string | null = null;
    private effTopOffset: string | null = null;

    private setOffset() {
        const dri: HTMLElement | null = document.getElementById('dri-thead');
        const cost: HTMLElement | null = document.getElementById('cost-thead');
        const eff: HTMLElement | null = document.getElementById('eff-thead');

        if (dri && cost && eff) {
            setTimeout(() => {
                this.driTopOffset = window.getComputedStyle(dri).height;
                this.costTopOffset = window.getComputedStyle(cost).height;
                this.effTopOffset = window.getComputedStyle(eff).height;
            }, 1000);
        }
    }


    // --------------------


    private get usrId() {
        if (store.state.user.sub === undefined) { return null; }
        return store.state.user.sub;
    }

    // =======Обновление целей БП и КР=========
    private async refreshGoals(isManualRefreshing: boolean = false) {
        if (!this.addProgamMode) {
            await this.loadBpGoalFrs();
        }
        // проверка изменилась ли цель и КР выбранные в данный момент. Если изменились тогда Выбранная цель сбрасывается.
        if (this.curBpGoal && this.curBpGoalFrs.length > 0) {
            this.goal = Number(this.curBpGoal.id);
            const curGoal = this.curBpGoalFrs.filter((item: any) => item.goal.id === this.curBpGoal.id);
            const newGoal = this.newGoalsAndFr.filter((item: any) => item.goal.id === this.curBpGoal.id);
            if (curGoal.length === 1 && newGoal.length === 1) {
                const curFrs: any[] = curGoal[0].finalResults;
                const newFrs: any[] = newGoal[0]['finalResults'];
                if (curFrs.length !== newFrs.length) {
                    this.goal = null;
                } else {
                    curFrs.forEach((curFr: any) => {
                        if (newFrs.findIndex((newFr: any) => newFr.finalResult.code === curFr.finalResult.code) === -1) {
                            this.goal = null;
                        }
                    });
                }
            }
        }
        if (this.newGoalsAndFr.length === 0) {
            if (!this.addProgamMode) {
                if (isManualRefreshing) this.resetGoalsAndFinalResults();
                this.makeToast('warning', this.getBPText('common.warning'), this.getBPText('msg.goals_not_found'));
            }
        } else {
            if (this.brbpWrapper) {
                if (!this.brbpWrapper.brbp) {
                    this.brbpWrapper.brbp = new Brbp(
                            this.curYear.year,
                            this.curRegion.code,
                            this.curAbp.abp,
                            this.curProg.prg,
                            null,
                            this.curBudgetVersion.variant_uuid,
                        );
                }
                this.brbpWrapper.brbp!.textGoalFr = { goalFinalResults: this.newGoalsAndFr };
                this.parseGoals(true);
                this.deleteNotExistedFrAtDriTable();
                const child = this.$refs.driEditModule as Vue & { updateTables: () => void };
                child.updateTables();
                this.makeToast('success', this.getBPText('msg.refresh_title'), this.getBPText('msg.goals_refreshed'));
            }
        }
    }

    private resetGoalsAndFinalResults(): void {
        this.curBpGoal = null;
        this.bpGoalsList.splice(0);
        this.curFinalResults.splice(0);
        this.deleteNotExistedFrAtDriTable();
        this.onDataChanged();
    }

    private deleteNotExistedFrAtDriTable(): void {
        let driData = this.brbpWrapper.driData;

        if (!this.bpGoalsList.length && this.brbpWrapper.brbp) {
            this.$set(this.brbpWrapper.brbp, 'textGoalFr', null);
            this.$set(this.brbpWrapper.brbp, 'goal', null);
        }

        let isHasNoPprAndHasDriData = driData && driData.length > 0;
        if (isHasNoPprAndHasDriData) {
            this.resetFinalResult(driData);
        }

        const pprData = this.brbpWrapper.pprData;
        const isHasPpr = pprData && pprData.length > 0;
        if (isHasPpr) {
            pprData.forEach((ppr: any) => {
                driData = ppr.driData;
                isHasNoPprAndHasDriData = driData && driData.length > 0;
                if (isHasNoPprAndHasDriData) {
                    this.resetFinalResult(driData);
                }
            })
        }
    }

    private resetFinalResult(driData: any): void {
        driData.forEach((dri: any) => {
            const driFinalResult = dri.finalResult;
            if (driFinalResult) {
                const isFinalResultActual = this.curFinalResults.findIndex((itm: any) => itm.code === driFinalResult) !== -1;
                if (!isFinalResultActual) this.$set(dri, 'finalResult', null);
            }
        })
    }

    // ------------------------ программа --------------------------
    private progBase: any[] = [];
    private curProg: any | null = null;

    private chgProg() {
        this.setFilter();
        this.loadData();
    }
    // ---------- подпрограмма
    private subProgBase: any[] = [];
    private curSubProg: any | null = null;

    private hasDriDataByPpr(ppr: any): boolean {
        if (!this.brbpWrapper || !this.brbpWrapper.pprData) return false;
        const entry = this.brbpWrapper.pprData.find((p: any) => p.brbp && p.brbp.ppr === ppr);
        return !!(entry && entry.driData && entry.driData.length > 0);
    }

    private hasProgramLevelDriData(): boolean {
        return !!(this.brbpWrapper && this.brbpWrapper.driData && this.brbpWrapper.driData.length > 0);
    }

    private get subProg(): any[] {
        const res: any[] = [];

        // В режиме «Заключение по БП» показываем только те БПП (и программу без подпрограмм),
        // по которым есть сохранённые данные в budget_request_bp_dri
        if (this.conclMode ? this.hasProgramLevelDriData() : (this.isNullSubProgActual || this.hasProgramLevelDriData())) {
            res.push({
                ppr: '000',
                name: this.getBPText('no_subprogram'),
                isActual: this.isNullSubProgActual
            });
        }

        for (const el of this.subProgBase) {
            const hasDriData = this.hasDriDataByPpr(el.ppr);
            if (this.conclMode ? !hasDriData : (!el.isActual && !hasDriData)) continue;
            res.push(this.setNameLang(el, 'ppr'));
        }
        return res;
    }

    public getSubProgramLabel(pprCode: any): string {
        const subProgram = this.subProgBase.find((el: any) => el.ppr === pprCode);
        return subProgram ? `${subProgram.ppr} – ${this.locName(subProgram)}` : String(pprCode);
    }

    private inactiveHintVisible = false;
    private inactiveHintPos = { top: 0, left: 0 };
    private showInactiveHint(event: MouseEvent) {
        const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
        this.inactiveHintPos = { top: rect.bottom + 4, left: rect.left };
        this.inactiveHintVisible = true;
    }
    private hideInactiveHint() {
        this.inactiveHintVisible = false;
    }
    private pendingDeleteSubProgPpr: any = null;
    private requestDeleteSubProg(ppr: any) {
        this.pendingDeleteSubProgPpr = ppr;
        this.$bvModal.show('delete-subprog-modal');
    }
    private async onDeleteSubProg() {
        const ppr = this.pendingDeleteSubProgPpr !== null ? this.pendingDeleteSubProgPpr : (this.curSubProg ? this.curSubProg.ppr : null);
        this.pendingDeleteSubProgPpr = null;
        if (ppr === null || ppr === undefined) return;

        if (ppr === '000' || ppr === 0) {
            this.brbpWrapper.driData = [];
            this.brbpWrapper.seeData = [];
            this.brbpWrapper.peeData = [];
            await this.save();
        } else {
            const pprIndex = this.brbpWrapper.pprData.findIndex((p: any) => p.brbp && p.brbp.ppr === ppr);
            const pprEntry = pprIndex !== -1 ? this.brbpWrapper.pprData[pprIndex] : undefined;
            if (!pprEntry || !pprEntry.brbp || !pprEntry.brbp.id) return;
            try {
                const response = await fetch(`api/budget-programs/brbp/${pprEntry.brbp.id}`, { method: 'DELETE' });
                if (response.status === 200) {
                    this.brbpWrapper.pprData.splice(pprIndex, 1);
                    this.makeToast('success', this.getBPText('msg.deletion'), this.getBPText('msg.subprogram_deleted'));
                    this.compareCostTotals();
                } else {
                    this.makeToast('danger', this.getBPText('msg.subprogram_delete_error'), `${response.status} - ${response.statusText}`);
                    return;
                }
            } catch (error) {
                this.makeToast('danger', this.getBPText('msg.subprogram_delete_error'), error.toString());
                return;
            }
        }

        this.curSubProg = null;
        this.chgSubProg();
    }

    private chgSubProg() {
        this.setFilter();
        this.afterChangePpr();
        this.setOffset();
        this.subProgNotActualAlertDismissed = false;
    }

    private subProgNotActualAlertDismissed = false;
    private get showSubProgNotActualAlert(): boolean {
        return !!(this.curSubProg && !this.curSubProg.isActual) && !this.subProgNotActualAlertDismissed;
    }
    private set showSubProgNotActualAlert(value: boolean) {
        this.subProgNotActualAlertDismissed = !value;
    }
    // Проекты и ППР
    private dictProjects: any[] = [];
    private dictDris: any[] = [];
    private dictSee: any[] = [];
    private dictUnits: any[] = [];

    // ----------- нормативно правовая основа
    private regulatoryBase: any[] = [];
    private curRegulatory: any[] = [];
    private curRegulatoryList: any[] = [];
    private regulatory() {
        this.searchNPA = '';
        const result: any[] = [];
        for (const el of this.regulatoryBase) {
            const newEl = Object.assign({}, el);
            result.push({ text: this.locName(newEl), value: newEl.id, filtered: false, selected: this.curRegulatory.includes(newEl.id) });
        }

        this.curRegulatoryList = result.sort((x, y) => { return (x.selected === y.selected)? 0 : x.selected ? -1 : 1; });
    }

    private get filteredCurRegulatoryList() {
        return this.curRegulatoryList.filter(item => {
            const isItemMatchSearch = item.filtered === false;
            const isNotBpModeOrItemSelected = !this.conclMode || this.curRegulatory.includes(item.value);
            return isItemMatchSearch && isNotBpModeOrItemSelected;
        })
    }

    // получение списка бюджетных программ для модалки
    private curBP: number | null = null;
    private actualBPList: any[] | null = [];
    private onOpenBPModal() {
        this.searchBP = '';
        this.curProg = null;
        this.curBP = null;
        this.curBpGoal = null;
        this.relativeFR = null;
        this.getBPList();
    }
    private getBPList(searchLine: string | null = null) {
        const result: any[] = [];
        for (const el of this.progBase) {
            if (!el.isActual) continue;
            const newEl = Object.assign({}, el);
            const text = `${newEl.prg} - ${this.locName(newEl)}`;
            if (searchLine) {
                if (text.toLowerCase().indexOf(searchLine.toLowerCase()) !== -1) {
                    result.push({ text, prg: newEl.prg, value: newEl.id });
                }
            } else {
                result.push({ text, prg: newEl.prg, value: newEl.id });
            }
        }
        result.sort((a: any, b: any) => a.prg - b.prg);
        const newResult: any[] = [];
        result.forEach((row: any) => {
            if (this.tableFieldsItems.findIndex((elem: any) => elem.id === row.value) === -1) {
                newResult.push(row);
            }
        });
        this.actualBPList = newResult;
    }
    private curPrgId: number | null = null;
    private curPrg() {
        if (this.actualBPList) {
            this.curPrgId = this.actualBPList.filter((item: any) => item.value === this.curBP)[0].prg;
        }
    }
    // добавление новой программы
    private addProgamMode = false;
    private onBPModalOk(e: any) {
        this.brbpCode = null;
        this.aggHistory.splice(0);
        this.goal = null;
        if (!this.curBP) {
            e.preventDefault();
            this.makeToast('warning', this.getBPText('common.warning'), this.getBPText('msg.select_program'));
        } else {
            this.addProgamMode = true;
            const currProgItem = this.progBase.filter(prg => prg.id === this.curBP)[0];
            this.curProg = currProgItem;
            this.handlePgrInUrl(this.curProg.prg);
            this.chgProg();
            this.switchPages();
            this.curPrg();
        }
    }

    // =========Удаление БП==========
    private bpId: number | null = null;
    private setBpId(bpId: number) {
        this.bpId = bpId;
    }
    private getBPText(field: string, params?: any): string {
        return this.$t(`modules.budget_request.budget_programs.${field}`, params) as string;
    }
    private onDeletePrg(row: any) {
        if (this.isDeleteDisabled(row)) return;
        this.setBpId(row.bpId);
        this.$bvModal.show('deletebp-modal');
    }
    private async onDelBP() {
        try {
            const response = await fetch(`api/budget-programs/brbp/${this.bpId}`, {
                method: 'DELETE'
            });
            if (response.status === 200) {
                const delId = this.tableFieldsItems.findIndex((elem: any) => elem.bpId === this.bpId);
                this.tableFieldsItems.splice(delId, 1);
                this.makeToast('success', this.getBPText('msg.deletion'), this.getBPText('msg.bp_deleted'));
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.bp_delete_error'), error.toString());
        }
    }

    // поиск по списку бюджетных программ в модалке
    private searchBP = '';

    private onSearchBP() {
        this.getBPList(this.searchBP);
    }

    // поиск по НПА
    private searchNPA = '';

    private onSearchNPA() {
        this.curRegulatoryList = this.curRegulatoryList.map((item: any) => {
            if (item.text.toLowerCase().indexOf(this.searchNPA.toLowerCase()) !== -1) {
                return { ...item, filtered: false };
            }
            return { ...item, filtered: true };
        });
    }

    // --------- Цель БП
    private curBpGoal: any = null;
    private bpGoalsList: any[] = [];
    private goal: number | null = null;
    private curBpGoalFrs: any[] = [];
    private relativeFR: any = null;
    private getFinalResultName(finalResultRec: any): string {
        let res = finalResultRec.finalResult.name_ru;
        const arr: any[] = finalResultRec.forecastYears;
        arr.sort((a: any, b: any) => (a.year > b.year) ? 1 : ((b.year > a.year) ? -1 : 0));
        for (const forecastYear of arr) {
            res = res + ` ${forecastYear.year} г. - ${forecastYear.plan};`;
        }
        return res;
    }
    private finalResultLabel(finalResult: any): string {
        return `${finalResult.code} - ${this.locName(finalResult, 'name_kz')}`;
    }
    private finalResultTableData = null;
    private updateFR(changed = false) {
        this.finalResultTableData = this.curBpGoalFrs[this.curBpGoal.recId];
        this.curFinalResults.splice(0);
        this.curBpGoalFrs.forEach(goalFr => {
            goalFr.finalResults.forEach((fr: any, i: number) => {
                this.curFinalResults.push({ ...fr.finalResult, name: this.finalResultLabel(fr.finalResult) });
            });
        })
    }

    // очистка конечного результата в ППР
    private ifFrsShouldBeCleared = false;

    // Парсинг целей БП
    private parseGoals(refresh = false) {
        this.bpGoalsList.length = 0;
        this.curBpGoal = null;
        this.relativeFR = null;
        this.finalResultTableData = null;
        this.curFinalResults.splice(0);
        if (this.brbpWrapper && this.brbpWrapper!.hasOwnProperty('brbp') && this.brbpWrapper.brbp!.textGoalFr) {
            const bpGoals = this.brbpWrapper.brbp!.textGoalFr!.goalFinalResults;
            this.curBpGoalFrs = JSON.parse(JSON.stringify(bpGoals));
            bpGoals.forEach((item: any, i: number) => {
                const goal = item.goal;
                this.bpGoalsList.push({
                    name: this.locName(goal, 'name_kz'),
                    name_ru: goal.name_ru,
                    name_kz: goal.name_kz,
                    id: goal.id,
                    recId: i,
                    goal: goal.code
                });
            });

            if (this.goal) {
                this.curBpGoal = this.bpGoalsList.filter((item: any) => {
                    return Number(item.id) === this.goal;
                })[0];
                if (this.curBpGoal) this.updateFR();
            }
        }
        if (!refresh) {
            this.checkIfGoalsAndFrActual();
        }
    }
    private newGoalsAndFr = [];
    private async loadBpGoalFrs() {
        if (!this.curYear || !this.curAbp || !this.curProg) {
            return;
        }
        const regionArg = this.curRegion ? `&region=${this.curRegion.code}` : '';
        try {
            const response = await fetch(`api/budget-programs/bp_frs?year=${this.curYear.year}&abp=${this.curAbp.abp}&prg=${this.curProg.prg}${regionArg}`);
            if (response.status === 200) {
                this.newGoalsAndFr = await response.json();
                this.showTop = false;
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.new_goals_error'), error.toString());
        }
    }

    // проверка актуальности целей БП и КР
    private showTop = false;
    private async checkIfGoalsAndFrActual() {
        if (this.conclMode) { return; }
        await this.loadBpGoalFrs();
        let goalsOrFrsChanged = false;
        if (this.newGoalsAndFr.length > 0 || this.curBpGoalFrs.length > 0) {
            if (this.newGoalsAndFr.length !== this.curBpGoalFrs.length) {
                goalsOrFrsChanged = true;
            }
            if (!goalsOrFrsChanged) {
                for (const newGoal of this.newGoalsAndFr) {
                    const index = this.curBpGoalFrs.findIndex((item: any) => newGoal['goal']['code'] === item.goal.code);
                    if (index === -1) {
                        goalsOrFrsChanged = true;
                        break;
                    } else {
                        const currGoal = this.curBpGoalFrs[index];
                        if (newGoal['finalResults']['length'] !== currGoal.finalResults.length) {
                            goalsOrFrsChanged = true;
                            break;
                        } else {
                            const newGoalFR: any[] = newGoal['finalResults'];
                            for (const newRes of newGoalFR) {
                                if (currGoal.finalResults.findIndex((curRes: any) => curRes.finalResult.code === newRes.finalResult.code) === -1) {
                                    goalsOrFrsChanged = true;
                                    break;
                                }

                                const newResCode = newRes.finalResult.code;
                                const currGoalRes = currGoal.finalResults.filter((fr: any) => fr.finalResult.code === newResCode)[0];
                                if (newRes.forecastYears.length !== currGoalRes.forecastYears.length) {
                                    goalsOrFrsChanged = true;
                                    break;
                                } else {
                                    for (let i = 0; i <= 2; i++) {
                                        const year = this.curYear.year + i;
                                        const a = newRes.forecastYears.filter((fry: any) => fry.year === year)[0];
                                        const b = currGoalRes.forecastYears.filter((fry: any) => fry.year === year)[0];
                                        if ((!a && b) || (a && !b)) {
                                            goalsOrFrsChanged = true;
                                            break;
                                        } else if (a && b && a.plan !== b.plan) {
                                            goalsOrFrsChanged = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (this.addProgamMode) {
            await this.refreshGoals();
            this.addProgamMode = false;
        } else if (this.editMode) {
            this.showTop = goalsOrFrsChanged;
            this.editMode = false;
            this.$emit('setBpInEditMode', false);
        }
    }

    // --------- в зависимости от уровня гос управления
    private govLevelBase: any[] = [];
    private curGovLevel: any | null = null;

    private get govLevel() {
        const result: any[] = [];
        for (const el of this.govLevelBase) {
            result.push(this.setNameLang(el, 'code'));
        }
        return result;
    }
    // -------------в зависимости от способа реализации
    private implementWayBase: any[] = [];


    private get implementWay() {
        const result: any[] = [];
        for (const el of this.implementWayBase) {
            result.push(this.setNameLang(el, 'code'));
        }
        return result;
    }
    // ------------ в зависимости от содержания
    private contentDictBase: any[] = [];
    private curContentDict: any | null = null;

    private get contentDict() {
        const result: any[] = [];
        for (const el of this.contentDictBase) {
            result.push(this.setNameLang(el, 'code'));
        }
        return result;
    }

    // ---------- текущая/развитие
    private bpStateBase: any[] = [];
    private get curBpState(): number {
        return (this.curProg && this.curProg.developType === PRG_DEV) ? PRG_DEV : PRG_CURR;
    }

    private set curBpState(value: number) {}

    private get isPrgDev(): boolean {
        return this.curBpState === PRG_DEV;
    }

    private get bpState() {
        return this.bpStateBase.map((el: any) => ({ ...el, name: this.getBPText(el.nameKey) }));
    }

    // ----------- список целей
    private goalsBase: any[] = [];
    private curGoals: any | null = null;

    private get goals() {
        const result: any[] = [];
        for (const el of this.goalsBase) {
            result.push(this.setNameLang(el, 'code', 'name_kz'));
        }
        return result;
    }

    // --------------- конечные результаты
    private finalResultBase: any[] = [];

    private get finalResult() {
        const result: any[] = [];
        for (const el of this.finalResultBase) {
            result.push(this.setNameLang(el, null, 'name_kz'));
        }
        return result;
    }

    // ------------Описание (обоснование) БП:
    private brbpDescr = { descrRu: '', descrKK: '' };

    // --------------описание (обоснование) БПП
    private bppDescr = { descrRu: '', descrKK: '' };

    // ---------------Описание влияния заявленного финансирования на достижение показателей результатов бюджетных программ
    private descrInfl: any = []; // программ
    private subDescrInfl: any = [{ descrRu: '', descrKk: '' }, { descrRu: '', descrKk: '' }, { descrRu: '', descrKk: '' }]; // подпрограмм
    // --------------- справочник показателей
    private indicDictBase: any[] = [];
    private curIndicDict: any | null = null;

    private get indicDict() {
        const result: any[] = [];
        for (const el of this.indicDictBase) {
            result.push(this.setNameLang(el, null, 'name_kz'));
        }
        if (result.length > 0 && this.curIndicDict === null) { this.curIndicDict = result[0]; }
        return result;
    }

    // управление правами доступа
    private modulecode: String = this.conclMode ? '004.003.006' : '004.002.008';
    private onlyReadMode = true;
    private userOperations: string[] = [];

    private async getAccessData() { // получение разрешенных доступов
        let response: any = {};
        if (!this.usrId) return;
         try {
            response = await fetch(`api/um/module/link?user=${this.usrId}&modulecode=${this.modulecode}`);
            if (response.status === 200) {
                response = await response.json();
                if (response.operations && response.operations.length) {
                    this.userOperations = response.operations;
                }
                this.setOnlyReadMode(response);

            } else {
                this.makeToast('danger', this.getBPText('msg.access_levels_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.access_levels_error'), error.toString());
        }
    }

    setOnlyReadMode(response: any) {
        // response.accessLevel = 1
        const editAllovedLevels = [2, 3];
        if (response.accessLevel && editAllovedLevels.includes(response.accessLevel)) {
            this.onlyReadMode = false;
        } else {
            this.onlyReadMode = true;
        }
    }

    private loadProg() { // загрузка программ, из уже загруженного allPrgsList (см. getAllPrgs) - тот же abp, без повторного запроса
        this.progBase = [];
        if (this.curAbp === null) return;

        const response = this.allPrgsList
            .filter((prg: any) => { return !!this.avlblGrpsList.find((ag: any) => ag.fgr === prg.gr); })
            .sort((a: any, b: any) => (a.prg - b.prg > 0) ? 1 : -1);
        this.progBase = this.setIdArr(response, 'prg');
    }

    private toDateStr(value: any): string | null {
        if (value === null || value === undefined) return null;
        if (typeof value === 'string') return value.slice(0, 10);
        const date = new Date(value);
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private checkIsActual(el: any): boolean {
        if (!this.curBudgetVersion) return false;
        const versionStartDate = this.toDateStr(this.curBudgetVersion.date_start);
        const versionEndDate = this.toDateStr(this.curBudgetVersion.end_date);
        const begDate = this.toDateStr(el.begDate ?? el.beg_date);
        const endDate = this.toDateStr(el.endDate ?? el.end_date);

        const isBegDateActual = begDate === null || versionEndDate === null || begDate <= versionEndDate;
        const isEndDateActual = endDate === null || versionStartDate === null || endDate >= versionStartDate;
        const isActualByPeriod = isBegDateActual && isEndDateActual;

        const planBudgetApprovalDataTypeCode = '2';
        if (this.curDataType && this.curDataType.code === planBudgetApprovalDataTypeCode) {
            const firstDayOfYear = `${this.curBudgetVersion.year}-01-01`;
            return isActualByPeriod || begDate === firstDayOfYear;
        }
        return isActualByPeriod;
    }

    // Сравнение двух записей ЕБК с одинаковым кодом: актуальная приоритетнее неактуальной,
    // среди равных по актуальности приоритет у end_date IS NULL, затем у наибольшего end_date.
    private isMoreActualByCode(candidate: any, current: any): boolean {
        const candidateIsActual = !!candidate.isActual;
        const currentIsActual = !!current.isActual;
        if (candidateIsActual !== currentIsActual) return candidateIsActual;

        const candidateEndDate = this.toDateStr(candidate.endDate ?? candidate.end_date);
        const currentEndDate = this.toDateStr(current.endDate ?? current.end_date);
        if (candidateEndDate === null) return currentEndDate !== null;
        if (currentEndDate === null) return false;
        return candidateEndDate > currentEndDate;
    }

    // Из записей ЕБК с одинаковым кодом оставляем только одну - наиболее актуальную.
    // Поле isActual должно быть уже проставлено (см. checkIsActual).
    private takeOneByCode(list: any[], codeFields: string[]): any[] {
        const byCode = new Map<string, any>();
        for (const el of list) {
            const code = codeFields.map((field: string) => el[field] ?? '').join('.');
            const current = byCode.get(code);
            if (current === undefined || this.isMoreActualByCode(el, current)) {
                byCode.set(code, el);
            }
        }
        return Array.from(byCode.values());
    }

    private nullSubPrograms: any[] = [];
    private async loadNullSubPrograms() {
        this.nullSubPrograms = [];
        if (!this.curProg) return;
        try {
            const response = await fetch(`/api-py/get-null-subprograms-by-gr-abp-prg/${this.curProg.gr}/${this.curProg.abp}/${this.curProg.prg}`);
            if (response.status === 200) {
                this.nullSubPrograms = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.data_load_error'), error.toString());
        }
    }

    private get actualNullSubPrograms(): any[] {
        return this.nullSubPrograms.filter((el: any) => this.checkIsActual(el));
    }

    private get isNullSubProgActual(): boolean {
        return this.actualNullSubPrograms.length > 0;
    }

    private async loadSubProg() { // загрузка справочника подпрограмм
        this.subProgBase = [];
        let response: any = [];
        if (this.curAbp !== null) {
            try {
                [response] = await Promise.all([
                    fetch(`/api-py/get-dict-func-childs-by-parent-type/${this.curProg.id}/5`),
                    this.loadNullSubPrograms()
                ]);
                if (response.status === 200) {
                    response = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', this.getBPText('msg.subprograms_load_error'), error.toString());
            }
        }
        if (Array.isArray(response)) {
            response = response.map((ppr: any) => ({ ...ppr, isActual: this.checkIsActual(ppr) }));
            response = this.takeOneByCode(response, ['abp', 'prg', 'ppr']);
        }
        this.subProgBase = response;
        this.commonResources.pprList = response;
        // БПП не предзаполняется: до выбора пользователем в поле отображается «Выберите БПП»,
        // ввод и сохранение данных по показателям недоступны
        this.curSubProg = null;
        this.chgSubProg();
    }
    private progress2 = 0;
    private async loadData(preload = false) {
        this.conclusions = {
            conclNpaRu: null,
            conclDescrRu: null,
            conclFrRu: null,
            conclExpendRu: null,
            conclDriRu: null,
            conclNpaCode: null,
            conclDescrCode: null,
            conclFrCode: null,
            conclExpendCode: null
        };
        this.selectedTable = 'ppr';
        this.newGoalsAndFr.length = 0;
        this.isDriDataReady = false;
        this.bpGoalsList.length = 0;
        this.curRegulatory.length = 0;
        this.isUserEditMode = false;
        let response: any = null;
        this.curGovLevel = null;
        this.curContentDict = null;
        this.curImplementWay = null;
        this.curGoals = null;
        this.curBpGoalFrs.length = 0;
        // this.getCurrStep = null;
        this.brbpDescr = { descrRu: '', descrKK: '' };
        if (this.curRegion === null || this.curAbp === null || this.curProg === null || this.curBudgetVersion === null) { return; }
        const url = `/api/budget-programs/brbp/find?plan_year=${this.curYear.year}&region=${this.curRegion.code}&abp=${this.curAbp.abp}&prg=${this.curProg.prg}&variant=${this.curBudgetVersion.variant_uuid}`;
        try {
            response = await fetch(url);
            if (response.status === 200) {
                response = await response.json();
            } else {
                if (response.status === 204 && !this.addProgamMode) {
                    this.makeToast('warning', this.getBPText('msg.data_loading'), this.getBPText('msg.no_data'));
                }
                if (response.status !== 200 && response.status !== 204) {
                    this.makeToast('danger', this.getBPText('msg.data_load_error'), `${response.status} - ${response.statusText}`);
                }
                response = null;
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.data_load_error'), error.toString());
            response = null;
        }
        this.progress2 = 20;
        await this.changeDriDataIdToObj(response);
        this.brbpWrapper = response ? await response : new BrbpWrapper();
        if (!preload) {
            this.loadNpa();
            await this.loadSubProg();
            this.parseGoals();
            this.progress2 = 50;
            this.loadBpExpends();
            this.setCurDicts();
            this.progress2 = 70;
            this.loadInflProg();
        }
        this.afterChangePpr();
        this.progress2 = 90;
        this.$nextTick(() => {
            this.isUserEditMode = true;
            this.dataChanged = false;
        });
        this.isDriDataReady = true;
        this.progress2 = 0;
        this.compareCostTotals();
        this.setConcl();
        this.getbrbpCode();
        this.loadConclHist();
        // this.setCurrStep();
    }

    private dictForecast: any[] = [];
    private async loadForecast() {
        try {
            const response: any = await fetch('/api/forecast');
            this.dictForecast = await response.json();
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.forecast_load_error'), error.toString());
        }
    }

    private async loadProjects() {
        try {
            const response: any = await fetch('/api/budget-programs/bp_project');
            this.dictProjects = await response.json();
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.projects_dict_error'), error.toString());
        }
    }

    private async loadDris() {
        try {
            const response: any = await fetch('/api/budget-programs/bp_dri');
            this.dictDris = await response.json();
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.ppr_dict_error'), error.toString());
        }
    }

    private async loadSee() {
        try {
            const response: any = await fetch('/api/budget-programs/bp_see');
            this.dictSee = await response.json();
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.see_dict_error'), error.toString());
        }
    }

    private async loadUnits() {
        try {
            const response: any = await fetch('/api/budget-programs/stat_unit');
            this.dictUnits = await response.json();
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.units_dict_error'), error.toString());
        }
    }

    private changeData(ppr: any) {
        ppr.driData.forEach((dri: any) => {
            const idProject = dri.project;
            if (idProject !== null) {
                dri.project = this.dictProjects.find((p: any) => p.id === idProject);
            }
            const idDri = dri.indicator;
            if (idDri !== null) {
                dri.indicator = this.dictDris.find((p: any) => p.id === idDri);
            }
        });
        ppr.peeData.forEach((pee: any) => {
            const idProject = pee.project;
            if (idProject !== null) {
                pee.project = this.dictProjects.find((p: any) => p.id === idProject);
            }
            const idDri = pee.indicator;
            if (idDri !== null) {
                pee.indicator = this.dictDris.find((p: any) => p.id === idDri);
            }
        });
        ppr.seeData.forEach((see: any) => {
            const idProject = see.project;
            if (idProject !== null) {
                see.project = this.dictProjects.find((p: any) => p.id === idProject);
            }
            const idSee = see.see;
            if (idSee !== null) {
                see.see = this.dictSee.find((p: any) => p.id === idSee);
            }
        });
    }

    private isDriDataReady = false;
    private async changeDriDataIdToObj(response: any) {
        await this.loadProjects();
        await this.loadDris();
        await this.loadUnits();
        const res: BrbpWrapper = response;
        if (res) {
            if (res.pprData && res.pprData.length > 0) {
                res.pprData.forEach((ppr: any) => {
                    this.changeData(ppr);
                });
            }
            this.changeData(res);
        }
        return res;
    }

    private changeDriDataObjToId(data: BrbpWrapper): BrbpWrapper {
        const changeHelper = (ppr: any) => {
            const driData: BrbpDri[] = [];
            ppr.driData.forEach((dri: any) => {
                const objProject = dri.project;
                if (objProject && objProject.id) {
                    dri.project = objProject.id;
                }
                const objDri = dri.indicator;
                if (objDri && objDri.id) {
                    dri.indicator = objDri.id;
                }
                driData.push(dri);
            });
            ppr.driData = driData;

            const seeData: BrbpSee[] = [];

            ppr.seeData.forEach((see: any) => {
                const objProject = see.project;
                if (objProject && objProject.id) {
                    see.project = objProject.id;
                }
                const objSee = see.see;
                if (objSee && objSee.id) {
                    see.see = objSee.id;
                }
                seeData.push(see);
            });
            ppr.seeData = seeData;

            const peeData: BrbpPee[] = [];
            ppr.peeData.forEach((pee: any) => {
                const objProject = pee.project;
                if (objProject && objProject.id) {
                    pee.project = objProject.id;
                }

                if (this.testIfHasFilledMoneyField(pee)) {
                    peeData.push(pee);
                }
            });
            ppr.peeData = peeData;
        };
        const res = JSON.parse(JSON.stringify(data));
        if (res.pprData && res.pprData.length > 0) {
            this.removeEmptyPprs(res);
            res.pprData.forEach((ppr: any) => {
                changeHelper(ppr);
            });
        }
        changeHelper(res);

        return res;
    }

    private removeEmptyPprs(res: BrbpWrapper) {
            const pprData = res.pprData;
        for (let i = pprData.length - 1; i >= 0; i--) {
            const ppr = pprData[i];
            const isDriEmpty = !ppr.driData || ppr.driData.length === 0;
            if (isDriEmpty) {
                res.pprData.splice(i, 1);
            }
        }
    }

    private testIfHasFilledMoneyField(pee: any): boolean {
        const moneyFields = ['expendCorrectPlan', 'expendReportYear', 'expendApprovedPlan',
                            'expendPlanPeriod1', 'expendPlanPeriod2',
                            'expendPlanPeriod3'];

        for (const fieldName of moneyFields) {
            const moneyAmount = pee[fieldName] ?? 0;
            if (moneyAmount > 0) return true;
        }
        return false;
    }

    private get allSubProgWrappers(): IBrbpWrapper[] {
        if (!this.brbpWrapper) return [];
        if (!this.brbpWrapper.pprData) {
            this.brbpWrapper.pprData = [];
        }
        return [this.brbpWrapper, ...this.brbpWrapper.pprData];
    }

    private afterChangePpr() {
        if (!this.brbpWrapper) {
            return;
        }
        if (!this.brbpWrapper.pprData) {
            this.brbpWrapper.pprData = [];
        }
        if (!this.curSubProg) {
            this.brbpPprSelected = new BrbpPprWrapper(undefined, [], [], []);
            return;
        }
        // '000' (нулевая подпрограмма) хранится на уровне самой программы (this.brbpWrapper, ppr === null),
        // а не как отдельная запись в pprData — так требует бэк (единая главная строка budget_request_bp с ppr IS NULL)
        const curPpr = this.curSubProg.ppr === '000' ? null : this.curSubProg.ppr;

        let brbpWrapper: IBrbpWrapper | undefined = this.allSubProgWrappers.find(i => i && i.brbp && i.brbp.ppr === curPpr);
        if (!brbpWrapper) { // добавлено так как иногда не срабатывает поиск из предыдущей строки
            this.allSubProgWrappers.forEach(i => {
                if (i.brbp && i.brbp.ppr === curPpr) {
                    brbpWrapper = i;
                }
            });
        }

        if (!brbpWrapper) {
            if (curPpr === null) {
                if (!this.brbpWrapper.brbp) {
                    this.brbpWrapper.brbp = new Brbp(
                        this.curYear.year,
                        this.curRegion.code,
                        this.curAbp.abp,
                        this.curProg.prg,
                        null,
                        this.curBudgetVersion.variant_uuid,
                    );
                }
                brbpWrapper = this.brbpWrapper;
            } else {
                brbpWrapper = new BrbpPprWrapper(
                    new Brbp(
                        this.curYear.year,
                        this.curRegion.code,
                        this.curAbp.abp,
                        this.curProg.prg,
                        curPpr,
                        this.curBudgetVersion.variant_uuid,
                    ),
                    [],
                    [],
                    []
                );
                this.brbpWrapper.pprData.push(brbpWrapper);
            }
        }
        this.brbpPprSelected = brbpWrapper;
        this.$set(this, 'brbpPprSelected', brbpWrapper);
        this.setDriByRegion();

        if (this.brbpPprSelected.driData && this.brbpPprSelected.driData.length > 1) {
            this.brbpPprSelected.driData = sortDriRowsByRegionAndId(this.brbpPprSelected.driData);
        }
    }

    private setDriByRegion() {
        if (!this.brbpPprSelected.brbp) return;
        // Начальное состояние чекбокса «Район/город» определяется полем budget_request_bp.dri_by_region:
        // если данные по БПП ещё не сохранялись (значение отсутствует/NULL) — по умолчанию включено
        // только для программ развития на областном уровне (код региона оканчивается на 0101),
        // где чекбокс скрыт и разрез по региону обязателен всегда.
        const isDriByRegionAlreadySelected = typeof this.brbpPprSelected.brbp.driByRegion === 'boolean';
        if (!isDriByRegionAlreadySelected) {
            this.$set(this.brbpPprSelected.brbp, 'driByRegion', this.defaultDriByRegion());
        }
    }

    public defaultDriByRegion(): boolean {
        return this.isPrgDev && this.filter?.region?.code?.slice(-4) === '0101';
    }

    private async loadRegulatory() { // загрузка нормативно правовой основы
        this.regulatoryBase = [];
        let response: any = [];
        try {
            response = await fetch('/api/budget-programs/npa');
            if (response.status === 200) {
                response = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.npa_dict_error'), error.toString());
        }
        response.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
        this.regulatoryBase = response;
    }

    private async loadGovLevel() { // уровень гос управления
        let response: any = [];
        this.govLevelBase = [];
        try {
            if (this.curAbp) {
                response = await fetch(`/api/budget-programs/bp_level?abp=${this.curAbp.abp}`);
                if (response.status === 200) {
                    response = await response.json();
                }
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.gov_level_error'), error.toString());
        }
        response.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
        this.govLevelBase = response;
        if (this.brbpWrapper && this.brbpWrapper.brbp && this.brbpWrapper.brbp.typeBpLevel) {
            this.curGovLevel = this.findObj(this.govLevelBase, this.brbpWrapper.brbp.typeBpLevel, 'code');
        }
    }

    private async loadContent() { // в зависимости от содержания
        let response: any = [];
        this.contentDictBase = [];
        try {
            response = await fetch('/api/budget-programs/bp_content');
            if (response.status === 200) {
                response = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.bp_content_error'), error.toString());
        }
        response.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
        this.contentDictBase = response;
        if (this.brbpWrapper && this.brbpWrapper.brbp && this.brbpWrapper.brbp.typeBpContent) {
            this.curContentDict = this.findObj(this.contentDictBase, this.brbpWrapper.brbp.typeBpContent, 'code');
        }
    }

    private async loadImplementWay() { // в зависимости от способа реализации
        let response: any = [];
        this.implementWayBase = [];
        try {
            response = await fetch('/api/budget-programs/bp_impl');
            if (response.status === 200) {
                response = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.bp_impl_error'), error.toString());
        }
        response.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
        this.implementWayBase = response;
        if (this.brbpWrapper && this.brbpWrapper.brbp && this.brbpWrapper.brbp.typeBpImpl) {
            this.curImplementWay = this.findObj(this.implementWayBase, this.brbpWrapper.brbp.typeBpImpl, 'code');
        }
    }

    private async loadBpState() { // текущее/развитие
        this.bpStateBase = [
                            { id: 0, code: '01', nameKey: 'card.bp_state_current' },
                            { id: 1, code: '02', nameKey: 'card.bp_state_development' }
                        ]
    }

    private async loadGoals() {
        let response: any = [];
        this.goalsBase = [];
        try {
            response = await fetch('/api/dict/program_goals');
            if (response.status === 200) {
                response = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.goals_dict_error'), error.toString());
        }
        response.sort((a: any, b: any) => (a.code > b.code) ? 1 : -1);
        this.goalsBase = response;
        if (this.brbpWrapper && this.brbpWrapper.brbp && this.brbpWrapper.brbp.goal) {
            this.curGoals = this.findObj(this.goalsBase, this.brbpWrapper.brbp.goal, 'code');
        }
    }

    private async loadInflProg() {
        this.descrInfl = [];
        let result: any[];
        if (this.brbpWrapper && this.brbpWrapper.brbp && this.brbpWrapper.brbp.id) {
            result = await this.loadDescrInfl(this.brbpWrapper.brbp.id);
            result = result.filter((i: any) => i.year >= this.curYear.year && i.year <= this.curYear.year + 2);
        } else {
            result = [];
        }
        for (let y = this.curYear.year; y <= this.curYear.year + 2; y++) {
            const item = result.find((infl: any) => infl.year === y);
            if (!item) {
                result.push({ year: y });
            }
        }
        result.sort((a: any, b: any) => a.year - b.year);
        this.descrInfl = result;
    }

    private async loadDescrInfl(id: number) {
        let response: any = [];
        // const result: any[] = [];
        if (!this.brbpWrapper || !this.brbpWrapper.brbp) {
            return [];
        }
        try {
            response = await fetch(`/api/budget-programs/budget_request_bp_infl?brbp=${id}`);
            if (response.status === 200) {
                response = await response.json();
            } else {
                response = [];
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.infl_load_error'), error.toString());
            response = [];
        }
        return response;
    }

    private async loadIndicDict() {
        let response: any = [];
        this.indicDictBase = [];
        try {
            response = await fetch('/api/dict/indicator');
            if (response.status === 200) {
                response = await response.json();
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.indicators_load_error'), error.toString());
        }
        this.indicDictBase = response;
    }

    private async loadNpa() { // загрузка нормативно правовой основы для программы
        let response: any = [];
        this.curRegulatory = [];
        if (!this.brbpWrapper || !this.brbpWrapper.brbp) {
            return;
        }
        try {
            response = await fetch(`/api/budget-programs/budget_request_bp_npa?brbp=${this.brbpWrapper.brbp.id}`);
            if (response.status === 200) {
                response = await response.json();
                for (const el of response) {
                    this.curRegulatory.push(el.id);
                }
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.bp_npa_load_error'), error.toString());
        }
    }

    // Расходы по БП

    private bpExpendsDataBase: Array<{
       [key: string] : number
    }> = [];
    private bpExpendsData: BpCosts = {};

    public async loadBpExpends() {
        if (!this.filter.region) {
            return;
        }
        let result: any = null;
        try {
            const response: any = await fetch(`/api/budget-programs/budget_request_bp/bpe?curr_year=${this.filter.year}&region=${this.filter.region.code}&abp=${this.filter.abp.abp}&prg=${this.filter.prg.prg}&variant=${this.filter.curVersion}`);
            if (response.status === 200) {
                result = await response.json();
                this.bpExpendsDataBase = result.sort((a: any, b: any) => a.ppr - b.ppr);
                this.fillDataForBpExpends();
            } else {
                this.makeToast('danger', this.getBPText('msg.expends_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.expends_load_error'), error.toString());
        }
    }

    public fillDataForBpExpends(): void {
        this.bpExpendsData = {};
        if (!this.bpExpendsDataBase.length) return;
        const copyBpExpendsDataBase = [];
        const totalSum = { 'kassRas': 0, 'approvedPlan': 0, 'utochPlan': 0, planPeriod1: 0, planPeriod2: 0, planPeriod3: 0 };
        for (const rec of this.bpExpendsDataBase) {
            const copy_rec = {...rec};
            copy_rec.kassRas = this.roundNumber(rec.kassRas, this.numberOfDecimalPlaces)
            copy_rec.approvedPlan = this.roundNumber(rec.approvedPlan, this.numberOfDecimalPlaces)
            copy_rec.utochPlan = this.roundNumber(rec.utochPlan, this.numberOfDecimalPlaces)
            copy_rec.planPeriod1 = this.roundNumber(rec.planPeriod1, this.numberOfDecimalPlaces)
            copy_rec.planPeriod2 = this.roundNumber(rec.planPeriod2, this.numberOfDecimalPlaces)
            copy_rec.planPeriod3 = this.roundNumber(rec.planPeriod3, this.numberOfDecimalPlaces)
            totalSum.kassRas += copy_rec.kassRas;
            totalSum.approvedPlan += copy_rec.approvedPlan;
            totalSum.utochPlan += copy_rec.utochPlan;
            totalSum.planPeriod1 += copy_rec.planPeriod1;
            totalSum.planPeriod2 += copy_rec.planPeriod2;
            totalSum.planPeriod3 += copy_rec.planPeriod3;
            copyBpExpendsDataBase.push(copy_rec);
        }
        this.bpExpendsData = {
            tableData: copyBpExpendsDataBase,
            totalSum: totalSum
        };

        this.compareCostTotals();
    }

    private setNameLang(obj: any, codeName?: any | null, kkField = 'name_kk'): any {
        let txt = this.locName(obj, kkField);
        if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
            txt = obj[codeName] + ' - ' + txt;
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        return el;
    }

    // получение всех программ
    private allPrgsList: any = [];
    private async getAllPrgs() {
        try {
            const result = await fetch(`api/budget-programs/ebk_func/prg?abp=${this.curAbp.abp}`)
                .then(response => response.json());
            const prgsList = result.map((prg: any) => ({ ...prg, isActual: this.checkIsActual(prg) }));
            this.allPrgsList = this.takeOneByCode(prgsList, ['abp', 'prg']);
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.request_prg_error'), error.toString());
        }
    }

    // получение всех групп
    private allGrpsList: any = [];
    private async getAllGrps() {
        try {
            this.allGrpsList = await fetch('api/budget-programs/ebk_func/gr')
                .then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.request_gr_error'), error.toString());
        }
    }

    //
    private avlblGrpsList: any = [];
    private async getAvlblGrps() {
        if (!this.usrId) return;
        try {
            this.avlblGrpsList = await fetch(`/api-py/user-fgr/${this.usrId}`)
                .then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.request_user_fgr_error'), error.toString());
        }
    }

    // получение всех групп
    private allAbpList: any = [];
    private async getAllAbps() {
        try {
            this.allAbpList = await fetch('api/budget-programs/ebk_func/abp')
                .then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.request_abp_error'), error.toString());
        }
    }

    private mainTableOverlay: boolean = false;
    private async uploadData(save = false) {
        if (!this.curRegion || !this.curYear || !this.curAbp) {
            return;
        }
        this.mainTableOverlay = true;
        if (!save) {
            this.isAllOpen = false;
        }
        let bps: any = [];
        if (this.curYear === null || this.curRegion === null || this.curAbp === null || this.curBudgetVersion === null) { return; }
        try {
            bps = await fetch(`/api/budget-programs/brbps?plan_year=${this.curYear.year}&region=${this.curRegion.code}&abp=${this.curAbp.abp}&variant=${this.curBudgetVersion.variant_uuid}`)
                .then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.request_brbps_error'), error.toString());
            return;
        }
        this.progress = 40;
        await this.getAllPrgs();
        this.progress = 60;
        let actualPrgsList: any = [];
        let program: any = [];
        let abpList: any = [];
        if (bps.length > 0 && this.allPrgsList.length > 0) {
            // получаем все программы
            bps.forEach((bp: any) => {
                if (!bp.ppr) {
                    program = this.allPrgsList.filter((prg: any) => prg.prg === bp.prg
                        && prg.abp === this.curAbp.abp
                        && prg.type === 4);
                    program.forEach((prog: any) => {
                        if (this.avlblGrpsList.find((ag: any) => ag.fgr === prog.gr)) {
                            abpList.push({ abp: prog.abp, gr: prog.gr });
                            actualPrgsList.push({ ...prog, bpId: bp.id, goal: bp.goal, conclExpendCode: bp.conclExpendCode, conclFrCode: bp.conclFrCode, approveStatus: bp.approveStatus });
                        }
                    });
                }
            });
            // получаем все абп
            await this.getAllAbps();
            this.progress = 90;
            abpList = this.removeDuplicates(abpList);
            abpList.forEach((prog: any) => {
                actualPrgsList = [...actualPrgsList, this.allAbpList.filter((item: any) => item.abp === prog.abp && item.gr === prog.gr)[0]];
            });
            // получение групп
            const grId: any = [];
            actualPrgsList.forEach((prg: any) => {
                if (grId.indexOf(prg.gr) === -1) {
                    grId.push(prg.gr);
                    actualPrgsList = [...actualPrgsList, ...this.allGrpsList.filter((gr: any) => gr.gr === prg.gr)];
                }
            });
        }
        this.loadProg();
        this.progress = 95;
        this.preparingTableData(actualPrgsList, save);
        this.progress = 0;
        await this.loadConclDict();
        this.mainTableOverlay = false;
    }

    private openProgramByDirectLink() {
        const currParams = this.$route.params;
        if (currParams.prg) {
            const programToOpen = this.tableFieldsItems.find((row: any) => row.prg === parseInt(currParams.prg));
            if (programToOpen) {
                this.onEdit(programToOpen, false);
            } else {
                this.handlePgrInUrl(-1);
            }
        }
    }

    private preparingTableData(data: any, save: boolean) {
        const newData: any = [];
        data.forEach((row: any) => {
            newData.push({ ...row });
        });

        newData.sort((a: any, b: any) => (b.gr < a.gr ? 1 : 0) - (a.gr < b.gr ? 1 : 0)
                                        || (b.abp < a.abp ? 1 : 0) - (a.abp < b.abp ? 1 : 0)
                                        || (b.prg < a.prg ? 1 : 0) - (a.prg < b.prg ? 1 : 0)
                                        || (b.type < a.type ? 1 : 0) - (a.type < b.type ? 1 : 0)
        );

        this.tableFieldsItems = newData;
        if (!save) {
            this.closeAll();
        }
        this.tableFieldsItems.forEach((row: any) => {
            row.open = false;
        });
        if (!save) {
            this.preloadData();
        }
    }
    private removeDuplicates(arr: any) {
        const result: any[] = [];
        const duplicatesIndices: any[] = [];

        // Перебираем каждый элемент в исходном массиве
        arr.forEach((current: any, index: number) => {
            if (duplicatesIndices.includes(index)) { return; }

            result.push(current);

            // Сравниваем каждый элемент в массиве после текущего
            for (let comparisonIndex = index + 1; comparisonIndex < arr.length; comparisonIndex++) {
                const comparison = arr[comparisonIndex];
                const currentKeys = Object.keys(current);
                const comparisonKeys = Object.keys(comparison);

                // Проверяем длину массивов
                if (currentKeys.length !== comparisonKeys.length) { continue; }

                // Проверяем значение ключей
                const currentKeysString = currentKeys.sort().join('').toLowerCase();
                const comparisonKeysString = comparisonKeys.sort().join('').toLowerCase();
                if (currentKeysString !== comparisonKeysString) { continue; }

                // Проверяем индексы ключей
                let valuesEqual = true;
                for (let i = 0; i < currentKeys.length; i++) {
                    const key = currentKeys[i];
                    if (current[key] !== comparison[key]) {
                        valuesEqual = false;
                        break;
                    }
                }
                if (valuesEqual) { duplicatesIndices.push(comparisonIndex); }
            } // Конец цикла
        });
        return result;
    }

    // решает баг с отображением данных в режиме редактирования при первом входе
    private async preloadData() {
        if (this.tableFieldsItems.length > 2) {
            this.goal = this.tableFieldsItems[2].goal;
            this.bpId = this.tableFieldsItems[2].bpId;
            this.curProg = this.tableFieldsItems[2];
            await this.loadData(true);
            this.openProgramByDirectLink()
        }
    }

    private isAllOpen = false;
    private closeAll() {
        this.isAllOpen = false;
        this.openAll();
    }
    private openAll() {
        this.isAllOpen = !this.isAllOpen;
        if (this.isAllOpen) {
            this.tableFieldsItems.forEach((row: any) => {
                if (row.type === 1) {
                    row.collapsed = false;
                    row.open = false;
                } else {
                    row.collapsed = true;
                    row.open = false;
                }
            });
        } else {
            this.tableFieldsItems.forEach((row: any) => {
                row.collapsed = false;
                row.open = true;
            });
        }
    }

    private toggleChilds(item: any, type: number) {
        this.tableFieldsItems = this.tableFieldsItems.map((row: any) => {
            if (type === 3 && row.gr === item.gr && (row.type === type)) {
                row.collapsed = !row.collapsed;
            }

            if (type === 4 && row.gr === item.gr && (row.type === type)) {
                row.collapsed = !row.collapsed;
            }

            if (row.id === item.id) {
                row.open = !row.open;
            }
            if (row.gr === item.gr && !item.open) {
                if (row.type === type) {
                    row.open = false;
                }
                if (row.type === type + 1) {
                    row.collapsed = true;
                    row.open = false;
                }
            }
            return row;
        });
    }

    private editMode = false;
    private onEdit(item: any, isUpdateUrl = true) {
        this.addProgamMode = false;
        this.curPrgId = item.prg;
        this.goal = item.goal;
        this.bpId = item.bpId;
        this.curProg = item;
        if (isUpdateUrl && this.curPrgId) this.handlePgrInUrl(this.curPrgId);
        this.editMode = true;

        this.$emit('setBpInEditMode', true);
        this.chgProg();
        this.switchPages();
    }

    handlePgrInUrl(prgId: number) {
        // if prgId < 0 the method is deleting prg param from url
        const filter: any = this.$refs.bpFilter;
        filter.handlePrgInRoute(prgId);
    }

    private cancelModalResolve: any = null;
    private async confirmNavigation() {
      return new Promise((resolve) => {
        this.$bvModal.show('cancel-modal');
        this.cancelModalResolve = resolve;
      });
    }

    private cancelModalHandleOk() {
      if (this.cancelModalResolve) {
        this.cancelModalResolve(true);
        this.cancelModalResolve = null;
      } else {
        this.switchPages('exitEditMode');
        this.handlePgrInUrl(-1);
      }
    }

    private cancelModalHandlCancel() {
      if (this.cancelModalResolve) {
        this.cancelModalResolve(false);
        this.cancelModalResolve = null;
      }
    }

    setRouterListener() {
        this.$router.beforeEach(async (to, from, next) => {
            if (!this.isHomePageActive) {
                if (this.dataChanged) {
                    const userConfirmed = await this.confirmNavigation();

                    if (userConfirmed) {
                        this.switchPages('exitEditMode');
                        next(); // Продолжаем навигацию, если пользователь подтвердил
                    } else {
                        next(false); // Отменяем навигацию, если пользователь отказался
                    }
                } else {
                    this.switchPages('exitEditMode');
                    next(); // Продолжаем, если данные не изменены
                }
            } else {
                next(); // Продолжаем, если на домашней странице
            }
        });
    }

    private created() {
        this.progress = 0;
        this.setRouterListener();
        this.watchOnDataEdit();
        this.loadAgreementOperations();
        this.loadRegulatory();
        this.loadContent();
        this.loadImplementWay();
        this.loadBpState();
        this.loadGoals();
        this.loadIndicDict();
        this.getAllGrps();
        this.loadSee();
        this.uploadConclAtr();
        this.loadPril3SvodAccess();
        this.$root.$emit('removeClass');

    }

    // при уходе с вкладки с открытым паспортом родитель иначе останется в режиме паспорта
    private beforeDestroy() {
        this.$emit('setBpInEditMode', false);
    }

    private watchOnDataEdit() {
        const that = this;
        this.$watch('searchNPA', function () { if (!that.searchNPA) { that.onSearchNPA(); } });
        this.$watch('searchBP', function () { if (!that.searchBP) { that.onSearchBP(); } });
        this.$watch('brbpWrapper', that.onDataChanged_brbpWrapper, { deep: true });
        this.$watch('curFinalResults', that.onDataChanged);
        this.$watch('curAbp', that.loadGovLevel);
        // this.$watch('aggrLevelCode', that.setCurrStep);
        // this.$watch('aggrLevelCode', that.setCurrStepinTable);
        this.$watch('numberOfDecimalPlaces', that.fillDataForBpExpends);
        this.$watch(() => this.$i18n.locale, that.onLocaleChanged);
        // curYear и curBudgetVersion меняются одновременно при применении фильтра - один вотчер по ключу, чтобы не дублировать запрос
        this.$watch(
            () => `${this.curYear && this.curYear.year}|${this.curBudgetVersion && this.curBudgetVersion.variant_uuid}`,
            that.loadReportVersionsActual
        );

    }

    private relabelSelected(selected: any | null, list: any[], key = 'id') {
        const fresh = selected && list.find((el: any) => el[key] === selected[key]);
        if (fresh) selected.name = fresh.name;
    }

    // выбранные значения хранятся копиями со старым name, поэтому имя обновляется на месте
    private onLocaleChanged() {
        this.relabelSelected(this.curGovLevel, this.govLevel);
        this.relabelSelected(this.curContentDict, this.contentDict);
        this.relabelSelected(this.curImplementWay, this.implementWay);
        this.relabelSelected(this.curSubProg, this.subProg, 'ppr');
        this.bpGoalsList.forEach((goal: any) => { goal.name = this.locName(goal, 'name_kz'); });
        this.curFinalResults.forEach((fr: any) => { fr.name = this.finalResultLabel(fr); });
        if (this.actualBPList && this.actualBPList.length) this.getBPList(this.searchBP);
    }

    private onDataChanged() {
        if (this.isUserEditMode && !this.dataChanged) {
            this.dataChanged = true;
        }
    }

    private onDataChanged_brbpWrapper(oldValue: any, newValue: any) {
        if (newValue instanceof BrbpWrapper) {
            return;
        }

    }

    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

    private setIdArr(arr: any[], codeName: string) {
        const result: any[] = [];
        for (const el of arr) {
            if (result.length > 0 && el[codeName] === result[result.length - 1][codeName]) {
                result[result.length - 1].idArr.push(el.id);
            } else {
                result.push(Object.assign({ idArr: [el.id] }, el));
            }
        }
        return result;
    }

    private isValid(brbpWrapper: BrbpWrapper): string {
        let emptyInd = false;
        brbpWrapper.pprData.forEach(p =>
            p.driData.forEach(d => {
                if (!d.indicator) {
                    emptyInd = true;
                }
            }
            )
        );
        let res = '';
        if (emptyInd) {
            res = res + 'ППР';
        }
        if (res) {
            return `В разделе 'Показатели прямого результата' присутствуют данные без ${res}`;
        }
        return '';
    }

    private formFlk(): string | null {
        let res: string | null = null;
        const reqFields: string[] = [];
        if (!this.curGovLevel) {
            reqFields.push('Вид БП: в зависимости от уровня государственного управления');
        }
        if (!this.curContentDict) {
            reqFields.push('Вид БП: в зависимости от содержания');
        }
        if (!this.curImplementWay) {
            reqFields.push('Вид БП: в зависимости от способа реализации');
        }
        if (reqFields.isNotEmpty) {
            const fields = reqFields.map(s => `"${s}`).join(', ');
            res = `Не заполнены обязательные для заполнения поля: ${fields}`;
        }
        return res;
    }

    // проверка заполненности полей перед сохраннением
    private isPrgSaving = false;
    private onSaveBtnClicked() {
        this.isPrgSaving = true;

        this.showTop = false;

        if (this.ifAllRequestedFieldsFilled()) {
            this.save();
        } else {
            this.isPrgSaving = false;
        }
    }

    private async save() {
        const removeTempId = (item: any, i?: number) => {
            item.driData.forEach((dri: any, z: number) => {
                if (dri.id) {
                    const strId = dri.id.toString();
                    if (strId.length >= 13) {
                        if (i !== undefined) {
                            delete this.brbpWrapper.pprData[i].driData[z].id;
                        } else {
                            delete this.brbpWrapper.driData[z].id;
                        }
                    }
                }
            });
            item.peeData.forEach((pee: any, z: number) => {
                if (pee.id) {
                    const strId = pee.id.toString();
                    if (strId.length >= 13) {
                        if (i !== undefined) {
                            delete this.brbpWrapper.pprData[i].peeData[z].id;
                        } else {
                            delete this.brbpWrapper.peeData[z].id;
                        }
                    }
                }
            });
            item.seeData.forEach((see: any, z: number) => {
                if (see.id) {
                    const strId = see.id.toString();
                    if (strId.length >= 13) {
                        if (i !== undefined) {
                            delete this.brbpWrapper.pprData[i].seeData[z].id;
                        } else {
                            delete this.brbpWrapper.seeData[z].id;
                        }
                    }
                }
            });
        };
        if (this.brbpWrapper.pprData.length > 0) {
            this.brbpWrapper.pprData.forEach((item: any, i: number) => {
                removeTempId(item, i);
            });
        }
        removeTempId(this.brbpWrapper);
        if (this.curRegion === null || this.curProg === null) { return; }
        let methServ = 'POST';
        if (this.brbpWrapper.brbp && this.brbpWrapper.brbp.id) {
            methServ = 'PUT';
        }

        if (!this.brbpWrapper.brbp) {
            this.brbpWrapper.brbp = new Brbp(this.curYear.year, this.curRegion.code, this.curAbp.abp, this.curProg.prg, null, this.curBudgetVersion.variant_uuid);
        }
        if (this.curGovLevel !== null) { this.brbpWrapper.brbp.typeBpLevel = this.curGovLevel.id; }
        if (this.curContentDict !== null) { this.brbpWrapper.brbp.typeBpContent = this.curContentDict.id; }
        if (this.curImplementWay !== null) { this.brbpWrapper.brbp.typeBpImpl = this.curImplementWay.id; }
        if (this.curBpGoal !== null) { this.brbpWrapper.brbp.goal = this.curBpGoal.id; }
        if (this.brbpDescr.descrKK && this.brbpDescr.descrKK.trim().length > 0) { this.brbpWrapper.brbp.descrKk = this.brbpDescr.descrKK.trim(); }
        if (this.brbpDescr.descrRu && this.brbpDescr.descrRu.trim().length > 0) { this.brbpWrapper.brbp.descrRu = this.brbpDescr.descrRu.trim(); }
        if (this.curAbp) { this.brbpWrapper.brbp.abp = this.curAbp.abp; }
        if (this.curProg) { this.brbpWrapper.brbp.prg = this.curProg.prg; }

        if (this.conclusions.conclNpaRu) { this.brbpWrapper.brbp.conclNpaRu = this.conclusions.conclNpaRu; }
        if (this.conclusions.conclDescrRu) { this.brbpWrapper.brbp.conclDescrRu = this.conclusions.conclDescrRu; }
        if (this.conclusions.conclFrRu) { this.brbpWrapper.brbp.conclFrRu = this.conclusions.conclFrRu; }
        if (this.conclusions.conclExpendRu) { this.brbpWrapper.brbp.conclExpendRu = this.conclusions.conclExpendRu; }
        if (this.conclusions.conclDriRu) { this.brbpWrapper.brbp.conclDriRu = this.conclusions.conclDriRu; }

        if (this.conclusions.conclNpaCode) { this.brbpWrapper.brbp.conclNpaCode = this.conclusions.conclNpaCode; }
        if (this.conclusions.conclDescrCode) { this.brbpWrapper.brbp.conclDescrCode = this.conclusions.conclDescrCode; }
        if (this.conclusions.conclFrCode) { this.brbpWrapper.brbp.conclFrCode = this.conclusions.conclFrCode; }
        if (this.conclusions.conclExpendCode) { this.brbpWrapper.brbp.conclExpendCode = this.conclusions.conclExpendCode; }
        const dataForSave = this.changeDriDataObjToId(this.brbpWrapper);
        // очистка от пустых строк раздела ППР
        dataForSave.pprData.forEach((it: any) => {
            it.driData = it.driData.filter((p: any) => p.budgetRequestBp
                || p.region || p.project || p.indicator || p.finalResult || p.reportYear
                || p.approvedPlan || p.correctPlan || p.planPeriod1 || p.planPeriod2 || p.planPeriod3
            );
        });
        dataForSave.driData = dataForSave.driData.filter((p: any) => p.budgetRequestBp
            || p.region || p.project || p.indicator || p.finalResult || p.reportYear
            || p.approvedPlan || p.correctPlan || p.planPeriod1 || p.planPeriod2 || p.planPeriod3
        );
        try {
            const url = '/api/budget-programs/brbp';
            let response: any = await fetch(url, {
                method: methServ,
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *client
                body: JSON.stringify(dataForSave) // body data type must match "Content-Type" header
            });
            if (response.status === 200) {
                this.makeToast('success', this.getBPText('msg.saving'), this.getBPText('msg.saved'));
                response = await response.json();
                this.brbpWrapper = JSON.parse(JSON.stringify(response))
                await this.changeDriDataIdToObj(this.brbpWrapper);
                this.afterChangePpr();
                this.getbrbpCode();
                await this.saveNPA(response.brbp.id);
                this.saveProgInfl(response.brbp.id);
                this.uploadData(true);
                this.loadBpExpends();
                const child = this.$refs.driEditModule as Vue & { updateTables: () => void };
                child.updateTables();
            } else {
                this.makeToast('warning', this.getBPText('msg.saving'), `${response.status} - ${response.statusText}`);
            }
            this.dataChanged = false;
        } catch (error) {
            this.makeToast('danger', this.getBPText('common.save_error'), error.toString());
        }
        this.isPrgSaving = false;
    }

    private async saveNPA(id: number) {
        try {
            const url = `/api/budget-programs/budget_request_bp_npa?brbp=${id}`;
            const response: any = await fetch(url, {
                method: 'PUT',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *client
                body: JSON.stringify(this.curRegulatory) // body data type must match "Content-Type" header
            });
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.npa_save_error'), error.toString());
        }
    }

    private async saveProgInfl(id: number) {
        await this.saveDescrInfl(this.descrInfl, id);
    }

    private async saveDescrInfl(inflObj: any[], id: number) {
        const saveObj: any[] = [];
        for (let i = 0; i < inflObj.length; i++) {
            const isDiscrFilled = inflObj[i].descr_kk || inflObj[i].descr_ru;
            if (isDiscrFilled) {
                saveObj.push(Object.assign({ year: (this.curYear.year + i + 1) }, inflObj[i]));
            }
        }
        try {
            const url = `/api/budget-programs/budget_request_bp_infl?brbp=${id}`;
            const response: any = await fetch(url, {
                method: 'PUT',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.infl_save_error'), error.toString());
        }
    }

    private setCurDicts() { // расставить значения из brbp
        if (!this.brbpWrapper || !this.brbpWrapper.brbp) {
            return;
        }
        this.curGovLevel = this.findObj(this.govLevel, this.brbpWrapper.brbp.typeBpLevel);
        this.curContentDict = this.findObj(this.contentDict, this.brbpWrapper.brbp.typeBpContent);
        this.curImplementWay = this.findObj(this.implementWay, this.brbpWrapper.brbp.typeBpImpl);
        // --
        this.curGoals = this.findObj(this.goals, this.brbpWrapper.brbp.goal);
        // await this.loadFinalResultBase();
        if (this.brbpWrapper.brbp.descrRu !== null) { this.brbpDescr.descrRu = this.brbpWrapper.brbp.descrRu!!; }
        if (this.brbpWrapper.brbp.descrKk !== null) { this.brbpDescr.descrKK = this.brbpWrapper.brbp.descrKk!!; }
    }

    private findObj(arr: any[], id?: number, codeName?: string | null) {
        if (!id) {
            return null;
        }
        if (arr === null || id === null) { return null; }
        for (const el of arr) {
            if (el.id === id) {
                if (el.name === undefined) {
                    return this.setNameLang(el, codeName);
                }
                return el;
            }
        }
        return null;
    }

    private setFilter() {
        this.filter = [];
        if (this.curAbp === null || this.curProg === null || this.curYear === null) {
            return;
        }
        const filter = {
            spf: null,
            from: null,
            gu: null,
            dataType: this.curDataType,
            abp: this.curAbp,
            prg: this.curProg,
            pgr: this.curSubProg,
            year: this.curYear.year,
            region: this.curRegion,
            bpState: this.curBpState,
            isPrgDev: this.isPrgDev,
            curBpGoal: this.curBpGoal,
            curVersion: this.curBudgetVersion.variant_uuid
        };
        this.$set(this, 'filter', filter);
    }

    // ============ breadcrumbs ==========
    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.bpFilter;
        drop.openFilterByRef(refName);
    }

    // переход между таблицами
    private selectedTable = 'ppr';
    private get tables() {
        return [
            { text: this.getBPText('card.table_ppr'), value: 'ppr' },
            { text: this.getBPText('card.table_eff'), value: 'eff' },
            { text: this.getBPText('card.table_cost'), value: 'cost' }
        ];
    }

    private forceRerender = 0
    private compareCostTotals() {
        const pprTotals: any[] = [];
        if (this.bpExpendsData.pprTotals) {
            delete this.bpExpendsData.pprTotals;
        }

        const pprData = this.allSubProgWrappers;

        pprData.forEach((ppr: any) => {
            const onePprTotals = {
                ppr: null,
                sumApprovedPlan: 0,
                sumCorrectPlan: 0,
                sumPlanPeriod1: 0,
                sumPlanPeriod2: 0,
                sumPlanPeriod3: 0,
                sumReportYear: 0
            };
            if (ppr.brbp && ppr.brbp.ppr) {
                onePprTotals.ppr = ppr.brbp.ppr;
                if (this.bpExpendsData && this.bpExpendsData.tableData) {
                    if (this.bpExpendsData.tableData.findIndex((item: any) => item.ppr === ppr.brbp.ppr) === -1) {
                        this.bpExpendsData.tableData.push({
                            kassRas: null,
                            approvedPlan: null,
                            planPeriod1: null,
                            planPeriod2: null,
                            planPeriod3: null,
                            ppr: onePprTotals.ppr,
                            utochPlan: null
                        });
                    }
                }
            }
            
            if (ppr.peeData && ppr.peeData.length > 0) {
                ppr.peeData.forEach((pee: any) => {
                    if (pee.expendApprovedPlan) { onePprTotals.sumApprovedPlan += this.roundNumber(Number(pee.expendApprovedPlan), this.numberOfDecimalPlaces); }
                    if (pee.expendCorrectPlan) { onePprTotals.sumCorrectPlan += this.roundNumber(Number(pee.expendCorrectPlan), this.numberOfDecimalPlaces); }
                    if (pee.expendPlanPeriod1) { onePprTotals.sumPlanPeriod1 += this.roundNumber(Number(pee.expendPlanPeriod1), this.numberOfDecimalPlaces); }
                    if (pee.expendPlanPeriod2) { onePprTotals.sumPlanPeriod2 += this.roundNumber(Number(pee.expendPlanPeriod2), this.numberOfDecimalPlaces); }
                    if (pee.expendPlanPeriod3) { onePprTotals.sumPlanPeriod3 += this.roundNumber(Number(pee.expendPlanPeriod3), this.numberOfDecimalPlaces); }
                    if (pee.expendReportYear) { onePprTotals.sumReportYear += this.roundNumber(Number(pee.expendReportYear), this.numberOfDecimalPlaces); }
                });
            }
            pprTotals.push(onePprTotals);
        });

        this.bpExpendsData.pprTotals = pprTotals;
        ++this.forceRerender;
    }

    // выход из режима редактирования программы
    private onExitEditMode() {
        if (this.dataChanged) {
            this.$bvModal.show('cancel-modal');
        } else {
            this.switchPages('exitEditMode');
            this.handlePgrInUrl(-1);
        }
    }

    private regionCityTrigger = 0;
    private onChangeRegionCity() {
        this.regionCityTrigger += 1;
        this.onDataChanged();
    }

    private addZero(numb: number) {
        if (numb >= 100) return numb;
        if (numb >=10) return '0' + numb.toString();
        else return '00' + numb.toString();
    }

    private reportVersionsActual: Record<string, IReportVersionActual | null> = {};

    // true только при ошибке загрузки справочника, не при пустом успешном ответе -
    // иначе fallback-ветки ниже сработают там, где справочник корректно ответил "версии нет"
    private reportVersionsLoadFailed = false;

    // pril1 и pril4 занимают один и тот же слот меню (диапазоны cur_year_beg/cur_year_end не пересекаются)
    private get mainReportCode(): string {
        if (this.reportVersionsActual.pril1) return 'pril1';
        if (this.reportVersionsActual.pril4) return 'pril4';
        return parseInt(this.curYear.year) >= 2026 ? 'pril4' : 'pril1';
    }

    private get mainReportDisplayName(): string {
        const actual = this.reportVersionsActual[this.mainReportCode];
        if (actual) return this.lng === 'kk' ? actual.display_name_kk : actual.display_name_ru;
        return `БП ${this.curAbp.abp} ${this.curPrgId}`;
    }

    private get isApp2Visible(): boolean {
        return !!this.reportVersionsActual.pril2 || (this.reportVersionsLoadFailed && parseInt(this.curYear.year) >= 2026);
    }

    private get app2DisplayName(): string {
        const actual = this.reportVersionsActual.pril2;
        if (actual) return this.lng === 'kk' ? actual.display_name_kk : actual.display_name_ru;
        return 'Приложение 2';
    }

    private get isApp3Visible(): boolean {
        return !!this.reportVersionsActual.pril3 || (this.reportVersionsLoadFailed && parseInt(this.curYear.year) >= 2026);
    }

    private get app3DisplayName(): string {
        const actual = this.reportVersionsActual.pril3;
        if (actual) return this.lng === 'kk' ? actual.display_name_kk : actual.display_name_ru;
        return 'Приложение 3';
    }

    // Приложение 3 (свод) - агрегированный отчет по всем АБП региона, доступен только пользователям с отдельным доступом
    private pril3SvodAccessAllowed = false;

    private get isPril3SvodVisible(): boolean {
        return this.pril3SvodAccessAllowed && !!this.reportVersionsActual.pril3_svod;
    }

    private get pril3SvodDisplayName(): string {
        const actual = this.reportVersionsActual.pril3_svod;
        if (actual) return this.lng === 'kk' ? actual.display_name_kk : actual.display_name_ru;
        return 'Приложение 3 (свод)';
    }

    private loadPril3SvodAccess() {
        const userUuid = this.$store.getters.user_uuid;
        if (!userUuid) {
            this.pril3SvodAccessAllowed = false;
            return;
        }
        Ax(
            {
                url: `/api-py/pril3_svod_access?user_uuid=${userUuid}`,
                method: 'GET'
            },
            (data: { has_access: boolean }) => {
                this.pril3SvodAccessAllowed = !!(data && data.has_access);
            },
            () => {
                this.pril3SvodAccessAllowed = false;
            }
        );
    }

    private loadReportVersionsActual() {
        if (!this.curYear || !this.curYear.year) {
            this.reportVersionsActual = {};
            this.reportVersionsLoadFailed = false;
            return;
        }
        if (!this.curBudgetVersion || !this.curBudgetVersion.variant_uuid) {
            this.reportVersionsActual = {};
            this.reportVersionsLoadFailed = false;
            return;
        }
        Ax(
            {
                url: '/api-py/dict_report_versions_actual',
                method: 'POST',
                data: {
                    mode_code: 'prg',
                    codes: ['pril1', 'pril4', 'pril2', 'pril3', 'pril3_svod'],
                    cur_year: parseInt(this.curYear.year),
                    variant_uuid: this.curBudgetVersion.variant_uuid
                }
            },
            (data: Record<string, IReportVersionActual | null>) => {
                this.reportVersionsActual = data || {};
                this.reportVersionsLoadFailed = false;
            },
            () => {
                this.reportVersionsActual = {};
                this.reportVersionsLoadFailed = true;
            }
        );
    }

    // номер отчёта, ожидающий подтверждения в download-modal/download-modal-list (проставляется перед открытием модалки)
    private pendingReportNumber: number | null = null;
    private confirmPendingReportGeneration() {
        if (this.pendingReportNumber !== null) this.bpReportGeneration(this.pendingReportNumber);
    }

    // загрузка отчета
    private isDownloadDisabled = false;
    private async bpReportGeneration(reportNumber: number, isAbpReport = false) {
        this.emitDownloadDisabled(isAbpReport, true);
        const curYear = parseInt(this.curYear.year);
        const programList = this.tableFieldsItems.filter((item: any) => item.prg !== null && item.prg !== undefined)
        .map((item: any) => item.prg);
        const params = JSON.stringify({
            curYear: curYear,
            region: this.curRegion.code,
            abp: this.curAbp.abp,
            prg: this.curPrgId ? this.curPrgId : null,
            ppr: this.curSubProg ? this.curSubProg.ppr : null,
            instCode: this.$store.getters.user_uuid,
            reportNumber: reportNumber,
            variant: this.curBudgetVersion.variant_uuid,
            programList: programList,
            info: this.getInfoData()
        });
        let urls = this.mainReportCode === 'pril4' ? '/api-py/bp_app_4_generations' : '/api-py/bp_generations';
        let text = ''
        if  (this.curAbp.abp && this.curPrgId) text = `${this.addZero(this.curAbp.abp)} ${this.addZero(this.curPrgId)}.xls`;
        let filename = `БП ${text}`;
        switch (reportNumber) {
            case 1:
                if (this.mainReportCode === 'pril4' && this.curPrgId) {
                    filename = `Приложение 4 - ${this.curAbp.abp}.${this.addZero(this.curPrgId)}.xls`;
                }
                break;
            case 2:
                urls = '/api-py/bpconcl_generations/';
                filename = `Заключение по БП ${text}.xls`;
                break;
            case 3:
                urls = '/api-py/abpconcl_gen/';
                filename = `Заключение по АБП ${this.addZero(this.curAbp.abp)}.xls`;
                break;
            case 4:
                urls = '/api-py/abpconcl_gen/';
                filename = `Заключение по АБП ${this.addZero(this.curAbp.abp)} без РБ.xls`;
                break;
            case 5:
                urls = '/api-py/bp_app_2_generations';
                filename = `Приложение 2 АБП ${this.addZero(this.curAbp.abp)}.xls`;
                break;
            case 6:
                urls = '/api-py/bp_app_3_generations';
                filename = `Приложение 3 АБП ${this.addZero(this.curAbp.abp)}.xls`;
                break;
            case 7:
                urls = '/api-py/bp_app_3_svod_generations';
                filename = 'Приложение 3 (свод).xls';
                break;
            }
        Ax(
            {
                url: urls, //  Тело файла
                method: 'POST',
                data: params,
                responseType: 'blob'
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);// or any other extension
                document.body.appendChild(link);
                link.click();
                this.emitDownloadDisabled(isAbpReport, false);
            },
            (error) => {
                //this.error = error;
                this.makeToast('danger', this.getBPText('msg.report_load_error'), error.toString());
                this.emitDownloadDisabled(isAbpReport, false);
            }
        );

    }

    private getInfoData() {
        return {
            sourceUrl: window.location.href,
            dateTime: this.getCurrentDateTime(),
            region: `${this.curRegion.code} ${this.locName(this.curRegion)}`,
            dataType: this.locName(this.curDataType),
            variant: this.locName(this.curBudgetVersion)
        }
    }

    private getCurrentDateTime() {
        const now = new Date();

        // Получаем часы, минуты и секунды
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        // Получаем день, месяц и год
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
        const year = now.getFullYear();

        // Форматируем дату и время
        const time = `${hours}:${minutes}`;
        const date = `${day}.${month}.${year}`;

        // Объединяем в одну строку
        return `${date} ${time}`;
    }

    private emitDownloadDisabled(isAbpReport: boolean, val: boolean) {
        this.isDownloadDisabled = val;
        if (isAbpReport) this.$emit('setDownloadDisabled', val);
    }

    private conclusions: any = {
        conclNpaRu: null,
        conclDescrRu: null,
        conclFrRu: null,
        conclExpendRu: null,
        conclDriRu: null,
        conclNpaCode: null,
        conclDescrCode: null,
        conclFrCode: null,
        conclExpendCode: null,
    };

    private setConcl() {
        if (this.brbpWrapper.brbp) {
            if (this.brbpWrapper.brbp.conclNpaRu) {
                this.conclusions.conclNpaRu = this.brbpWrapper.brbp.conclNpaRu;
            }
            if (this.brbpWrapper.brbp.conclDescrRu) {
                this.conclusions.conclDescrRu = this.brbpWrapper.brbp.conclDescrRu;
            }
            if (this.brbpWrapper.brbp.conclFrRu) {
                this.conclusions.conclFrRu = this.brbpWrapper.brbp.conclFrRu;
            }
            if (this.brbpWrapper.brbp.conclExpendRu) {
                this.conclusions.conclExpendRu = this.brbpWrapper.brbp.conclExpendRu;
            }
            if (this.brbpWrapper.brbp.conclDriRu) {
                this.conclusions.conclDriRu = this.brbpWrapper.brbp.conclDriRu;
            }
            if (this.brbpWrapper.brbp.conclNpaCode) {
                this.conclusions.conclNpaCode = this.brbpWrapper.brbp.conclNpaCode;
            }
            if (this.brbpWrapper.brbp.conclDescrCode) {
                this.conclusions.conclDescrCode = this.brbpWrapper.brbp.conclDescrCode;
            }
            if (this.brbpWrapper.brbp.conclFrCode) {
                this.conclusions.conclFrCode = this.brbpWrapper.brbp.conclFrCode;
            }
            if (this.brbpWrapper.brbp.conclExpendCode) {
                this.conclusions.conclExpendCode = this.brbpWrapper.brbp.conclExpendCode;
            }
        }
    }

    private selectedConcl1: any = null;
    private selectedConcl2: any = null;
    private conclAttributes1 = [];
    private conclAttributes2 = [];

    private async uploadConclAtr() {
        try {
            const response1 = await fetch(`/api/budget-programs/bp_conclusion_type1`);
            if (response1.status === 200) {
                this.conclAttributes1 = this.fillEmptyKkName(await response1.json())
                this.conclAttributes1.sort((a: any, b: any) => a.code - b.code)
            }
            const response2 = await fetch(`/api/budget-programs/bp_conclusion_type2`);
            if (response2.status === 200) {
                this.conclAttributes2 = this.fillEmptyKkName(await response2.json())
                this.conclAttributes2.sort((a: any, b: any) => a.code - b.code)
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.concl_type_load_error'), error.toString());
        }
    }

    // список общий для радиогрупп здесь и в c-table-dri-edit (text-field), где запасного русского нет
    private fillEmptyKkName(list: any): any {
        list.forEach((rec: any) => { if (!rec.name_kk) rec.name_kk = rec.name_ru; });
        return list;
    }

    private get localName() {
      return this.getLocalName()
    }

    private getLocalName() {
          let fieldName = 'name_ru';
        if (this.$i18n.locale === 'kk') {
            fieldName = 'name_kk';
        };
        return fieldName;
    }

    private getAttrText(code: string, dicType: number): string {
        const dict = dicType === 1 ? this.conclAttributes1 : this.conclAttributes2;
        if (dict) {
            const dictRow = dict.filter((rec: any) => rec.code === code)[0];
            if (dictRow) {
                return this.locName(dictRow);
            }
        }
        return '';
    }

    private get isConclButtonsDisabled() {
        if (this.onlyReadMode) return true;
        if (this.conclMode) {
            if (!this.currAggrOperation.includes('uebp_agree')) return true;
        }
        return false;
    }

    // управление состояниями при согласовании
    private get itputState() {
        if (this.onlyReadMode) return 'budgetprogramdisabled'
        if (!this.isCurBudgetVersionActive) return 'budgetprogramdisabled';
        if (!this.isCurPrgActual) return 'budgetprogramdisabled';
        if (!this.conclMode) {
            if (this.currAggrOperation.includes('abp_sign')) return null;
            return 'budgetprogramdisabled';
        }
        return 'budgetprogramdisabled';
    }

    private get conclState() {
        if (!this.showConcl) return 'budgetprogramhidden';
        if (!this.isCurPrgActual || !this.isCurBudgetVersionActive) return 'budgetprogramdisabled';
        if (this.conclMode) {
            if (this.onlyReadMode) return 'budgetprogramdisabled'
            if (this.currAggrOperation.includes('uebp_agree')) return null;
            return 'budgetprogramdisabled';
        } else {
            if (!this.currAggrOperation.includes('concl_bp')) return 'budgetprogramhidden';
            return 'budgetprogramdisabled';
        }
    }

    private isDeleteDisabled(item: any) {
        if (this.isProgramCanBeDelOrAdded) return true;
        if (!item || !item.approveStatus) return false;

        const curItemOperation = this.aggOperations[parseInt(item.approveStatus)]
        if (curItemOperation && !curItemOperation.includes('abp_sign')) return true;

        return false;
    }

    private get isProgramCanBeDelOrAdded() {
        return this.conclMode || this.onlyReadMode || !this.isCurBudgetVersionActive;
    }

    // Согласование
    private conclDict: any[] | null = null;
    private async loadConclDict() {
        let response: any = [];
        try {
            const param = encodeURI(JSON.stringify({ mode_code: 'prg' }));
            response = await fetch(`/api-py/get-all-agreement-status/${param}`);
            if (response === null) {
                this.makeToast('danger', this.getBPText('msg.statuses_load_error'), `${response}`);
                response = [];
            } else if (response.status === 200) {
                response = await response.json();
                this.conclDict = response;
            } else {
                this.makeToast('danger', this.getBPText('msg.statuses_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            this.makeToast('danger', this.getBPText('msg.statuses_load_error'), (error as Error).toString());
        }
    }

    private async saveConclStep(body: any) {
        if (!body) return;
        try {
            const url = '/api/budget-programs/approve_status';
            const response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *client
                body: JSON.stringify(body) // body data type must match "Content-Type" header
            });
            if (response.status === 200) {
                const resp = await response.json();
                this.makeToast('success', this.getBPText('msg.status_saved'), this.getBPText('msg.status_saved'));
                this.loadConclHist();
                this.setCurrProgApproveStatus(resp);
                this.setCurrStepinTable(resp);
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('common.save_error'), error.toString());
        }
    }

    private aggHistory: any[] = []
    private async loadConclHist() {
        if (!this.brbpCode) return;
        let response: any = [];
        try {
            response = await fetch(`/api/budget-programs/approve_status/${this.brbpCode}`);
            if (response === null) {
                this.makeToast('danger', this.getBPText('msg.statuses_load_error'), `${response}`);
                response = [];
            } else if (response.status === 200) {
                response = await response.json();
                this.aggHistory = response.sort((a:any, b: any) => { return a.updateTime - b.updateTime });
            } else {
                this.makeToast('danger', this.getBPText('msg.statuses_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            response = [];
            this.makeToast('danger', this.getBPText('msg.statuses_load_error'), (error as Error).toString());
        }
    }

    private aggOperations: any[] = []
    private async loadAgreementOperations() {
        try {
            const response = await fetch(`/api-py/get-agreement-operations/prg`);
            if (response.status === 200) {
                const result = await response.json();
                this.aggOperations = result;
            } else {
                this.makeToast('danger', this.getBPText('msg.operations_load_error'), `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.makeToast('danger', this.getBPText('msg.operations_load_error'), (error as Error).toString());
        }
    }

    private get agrCodesDict() {
        if (!this.conclDict) return [];
        const codesList: any[] = [];
        this.conclDict.forEach((item: any) => {
            if (item.stepBack.length || item.stepForward.length) {
                const stepBack = item.stepBack.length ? item.stepBack[0].step_code : null;
                const stepForward = item.stepForward.length ? item.stepForward[0].step_code : null;
                const codeListItem: any = {};
                this.$set(codeListItem, 'id', item.id);
                this.$set(codeListItem, 'code', item.code);
                this.$set(codeListItem, 'name_ru', item.name_ru);
                this.$set(codeListItem, 'name_kk', item.name_kk || item.name_ru);
                this.$set(codeListItem, 'prev_step', stepBack);
                this.$set(codeListItem, 'next_step', stepForward);
                this.$set(codeListItem, 'btn_name_kk', item.btn_name_kk || item.btn_name_ru);
                this.$set(codeListItem, 'btn_name_ru', item.btn_name_ru);
                codesList.push(codeListItem)
            }
        })
        return codesList;
    }

    private brbpCode: number | null = null
    private getbrbpCode() {
        this.brbpCode = null;
        if (this.brbpWrapper.brbp && this.brbpWrapper.brbp.id && this.brbpWrapper.brbp.id !== this.brbpCode) this.brbpCode = this.brbpWrapper.brbp.id;
    }

    private errors: any[] = [];
    private get canMoveForward() {
        const errorsDict:any = {
            conclNpaCode: 'concl.err_npa',
            conclDescrCode: 'concl.err_descr',
            conclFrCode: 'concl.err_fr',
            conclExpendCode: 'concl.err_expend',
            conclDescrInflCode: 'concl.err_ppr',
            conclSeeCode: 'concl.err_see',
            conclPeeCode: 'concl.err_pee'
        }
        let result: boolean = true;
        if (this.brbpWrapper && this.brbpWrapper.brbp) {
            this.errors.splice(0)
            for (const [i, [key, value]] of Object.entries(Object.entries(errorsDict))) {
                if (parseInt(i) < 4) {
                    if (this.conclusions[key] && this.conclusions[key] === "1") {
                        result = result && true;
                    } else {
                        result = result && false;
                        this.errors.push(this.getBPText(value as string));
                    }
                } else {
                    // Заключения требуем только по тем БПП, которые доступны для выбора на вкладке «Показатели»:
                    // иначе согласование блокировалось бы по БПП, которую УО не может открыть
                    const availablePpr = this.subProg.map((sp: any) => (sp.ppr === '000' ? null : sp.ppr));
                    const savedPpr: IBrbpWrapper[] = this.allSubProgWrappers.filter((ppr: any) =>
                        ppr.brbp?.id && availablePpr.includes(ppr.brbp.ppr ?? null));
                    savedPpr.forEach((ppr: any) => {
                        const brbp = ppr.brbp;
                        if (brbp && brbp[key] && brbp[key] === "1") {
                            result = result && true;
                        } else {
                            result = result && false;
                            this.errors.push(this.getBPText(value as string, { ppr: brbp.ppr ? brbp.ppr : '0' }));
                        }
                    })
                }

            }
        }
        return result;
    }

    private get getSigner() {
        if (!this.conclDict) return null;
        const currStep = this.conclDict.filter((item:any) => item.code === this.aggrLevelCode)[0];
        if (!currStep || !currStep.operation.length) return null;
        return currStep.operation[0].code;
    }

    private get disableConclBtns() {
        if (this.onlyReadMode) return true;
        if (!this.currAggrOperation) return true;
        if (this.conclMode) {
            if (!this.currAggrOperation.includes('abp_sign') && this.currAggrOperation.includes('uebp_agree')) return false;
            if (!this.currAggrOperation.includes('abp_sign') && !this.currAggrOperation.includes('uebp_agree')) return false;
        } else {
            if (this.currAggrOperation.includes('abp_sign') && !this.currAggrOperation.includes('uebp_agree')) return false;
        }
        return true;
    }

    private get aggrLevelCode() {
        return (this.curProg && parseInt(this.curProg.approveStatus)) || 1;
    };
    private set aggrLevelCode(value: number) {}

    private get currAggrOperation() {
        return this.aggOperations[this.aggrLevelCode];
    }

    private showConcl: boolean = this.conclMode;

    private get getCurrStep() {
        const currStepName = this.getStateName(this.aggrLevelCode);
        return currStepName || null
    }

    private setCurrProgApproveStatus(statusData: any): void {
        this.$set(this.curProg, 'approveStatus', statusData.approveStatus);
    }

    private setCurrStepinTable(statusData: any) {
        if (this.tableFieldsItems.length && statusData && statusData.approveStatus) {
            this.tableFieldsItems = this.tableFieldsItems.map((item: any) => {
                if (item.bpId === statusData.budgetRequestBp) {
                    this.$set(item, 'approveStatus', statusData.approveStatus);
                }
                return item;
            })
        }
    }

    // получение локализованного имени поля
    private get fieldLocalName() {
        return this.$i18n.locale === 'kk' ? 'name_kk' : 'name_ru';
    }

    private getStateName(code: number) {
        if (!this.agrCodesDict.length) return;
        const newCode: number = code || 1;
        const currStep = this.agrCodesDict.find((item: any) => item.code === newCode);
        if (!currStep) return;
        return this.locName(currStep);
    }

    // блокировка разделов в зависимости от решения
    private getEditClass(fieldName: string) {
        if (this.onlyReadMode) return 'budgetprogramdisabled';

        const codesAllowingEditing = ['2', '3', null, undefined];
        if (codesAllowingEditing.includes(this.conclusions[fieldName])) return null;

        return 'budgetprogramdisabled';
    }

    private get blockNpaClass() {
        return this.getEditClass('conclNpaCode');
    }

    private get blockDescrClass() {
        return this.getEditClass('conclDescrCode');
    }

    private get blockFrClass() {
        return this.getEditClass('conclFrCode');
    }

    private get blockRegionCheckbox() {
        if (this.onlyReadMode) return 'budgetprogramdisabled';
        if (this.brbpPprSelected.brbp && (this.brbpPprSelected.brbp.conclDescrInflCode === "1" || this.brbpPprSelected.brbp.conclSeeCode === "1" || this.brbpPprSelected.brbp.conclPeeCode === "1")) return 'budgetprogramdisabled';
        return null
    }

    private onBPModalClick(evnt: any) {
        if (evnt.target.classList.contains("custom-control-label") || evnt.target.parentElement.classList.contains("custom-control-label")) {
            this.onBPModalOk(evnt);
            const drop: any = this.$refs.selectbpModalRef;
            drop.hide(true);
        }
    } // создание программы по двойному щелчку

    public fillValidationMsgsMain(validationMsgs: string[]): void {
        if (this.curRegulatory.length === 0) {
            validationMsgs.push(this.getBPText('card.npa_label'));
        }
        if (!this.curGovLevel || !this.curContentDict || !this.curImplementWay) {
            validationMsgs.push(this.getBPText('validation.bp_kind'));
        }

        if (this.bpGoalsList.length > 0 && !this.curBpGoal) {
            validationMsgs.push(this.getBPText('validation.bp_goal'));
        }
    }

    private getTitle(obj: any, fieldName: string  = 'name') {
        if (obj && obj[fieldName]) return  obj[fieldName];
        return '';
    }

    private get isSaveBtnDisabled() {
        if (this.onlyReadMode) return true;
        if (!this.isCurPrgActual) return true;
        if (this.conclMode && this.currAggrOperation.includes('uebp_agree')) return false;
        if (!this.conclMode && this.currAggrOperation.includes('abp_sign')) return false;
        return true;
    }

    private get isAddBtnDisabled() {
        if (!this.conclMode && !this.onlyReadMode) return false;
        return true;
    }

    private get isRefreshGoalsBtnDisabled() {
        if (!this.conclMode) {
            if (!this.onlyReadMode && this.currAggrOperation.includes('abp_sign')) return false;
        }
        return true;
    }

    private get isActionBtnDisabled() {
        if (this.onlyReadMode) return true;
        if (!this.isCurPrgActual) return true;
        if (this.conclMode) {
            if (this.userOperations.includes('uebp_agree') && !this.currAggrOperation.includes('abp_sign')) return false;
        } else {
            if (this.userOperations.includes('abp_sign') && this.currAggrOperation.includes('abp_sign')) return false;
        }
        return true;
    }

    private get isCurBudgetVersionActive(): boolean {
        return !!(this.curBudgetVersion && this.curBudgetVersion.isVersionActive);
    }

    private get isCurPrgActual(): boolean {
        return !this.curProg || !!this.curProg.isActual;
    }

    private get isCurSubProgActual(): boolean {
        return !this.curSubProg || !!this.curSubProg.isActual;
    }

    // Пока БПП не выбрана, таблицы вкладки «Показатели» только отображаются: ввод и добавление строк недоступны
    private get driTablesItputState(): string | null {
        if (!this.curSubProg || !this.isCurSubProgActual) return 'budgetprogramdisabled';
        return this.itputState;
    }

    private get driTablesConclState(): string | null {
        if (this.conclState === 'budgetprogramhidden') return this.conclState;
        if (!this.curSubProg || !this.isCurSubProgActual) return 'budgetprogramdisabled';
        return this.conclState;
    }

    private prgFromUrl: number | undefined
    private curRegion: any | null = null;
    private curYear: any = {};
    private curAbp: any | null = null;
    private curBudgetVersion: any | null = null;
    private curDataType: any = null;
    private filterChanged(filterParams: any) {
        if (filterParams.urlParams) {
            this.prgFromUrl = filterParams.urlParams.prg;
        } else this.prgFromUrl = undefined;

        if (filterParams.curRegion) {
            this.curRegion = this.copyObject(filterParams.curRegion);
        } else this.curRegion = null;

        if (filterParams.curYear) {
            this.curYear = this.copyObject(filterParams.curYear);
        } else this.curYear = {};

        if (filterParams.curAbp) {
            this.curAbp = this.copyObject(filterParams.curAbp);
        } else this.curAbp = null;

        if (filterParams.curBudgetVersion) {
            this.curBudgetVersion = this.copyObject(filterParams.curBudgetVersion);
        } else this.curBudgetVersion = null;

        if (filterParams.curDataType) {
            this.curDataType = this.copyObject(filterParams.curDataType);
        } else this.curDataType = null;

        this.uploadData();
    }

    private copyObject(obj: {}) {
        return JSON.parse(JSON.stringify(obj));
    }

    private setProgress(value: number) {
        this.progress = value;
    }

    private onBudgetLevelLoaded() {
        this.getAvlblGrps();
        this.getAccessData();
    }

    private setRegions(regions: any[]) {
        this.regions = regions;
    }

}
